import {
  useState,
  useEffect,
  useCallback } from 'react';
import { useColorModeValue } from "./ui/color-mode";
import { useNavigate,
  useParams,
  useLocation,
  useSearchParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { getPerfilDisplayName } from '../utils/miEntidadNombreDefecto';
import { resolveUploadsUrl } from '../utils/staticUrl.js';
import { resolveBandaFromUser,
  resolveCofradiaFromUser } from '../utils/acuerdoParties.js';
import { eventosAPI,
  mensajesAPI,
  acuerdosAPI,
  resenasAPI } from '../services/api';
import ActuacionMapPreview from './ActuacionMapPreview.jsx';
import ReviewForm from './ReviewForm.jsx';
import { isEventoEfectivamenteFinalizado } from '../utils/eventoInicio.js';
import {
  Box,
  Flex,
  AspectRatio,
  Container,
  VStack,
  HStack,
  Text,
  Card,
  Heading,
  Badge,
  Icon,
  Tabs,
  Button,
  SimpleGrid,
  useDisclosure,
  IconButton,
  Alert,
  Breadcrumb,
  Input,
  Textarea,
  NumberInput,
  Spinner,
  Progress,
  Image,
  Wrap,
  WrapItem,
  Checkbox,
  Separator,
  Field,
  List,
  Dialog,
  Portal,
} from '@chakra-ui/react';
import { Avatar } from '@/components/ui/avatar';
import { TabList, TabPanels, Tab, TabPanel, Switch, tabsControlledValue, tabsOnValueChange } from '@/components/ui/chakra-v2-compat';
import { toaster } from '@/components/ui/toaster';
import { Tooltip } from '@/components/ui/tooltip';
import {
  FaCalendarCheck,
  FaMapMarkerAlt,
  FaClock,
  FaMusic,
  FaChurch,
  FaCheckCircle,
  FaHourglass,
  FaInfoCircle,
  FaEnvelope,
  FaSearch,
  FaTimes,
  FaHeart,
  FaArrowLeft,
  FaChevronRight,
  FaHandshake,
  FaEuroSign,
  FaFileAlt,
  FaStickyNote,
  FaTrash,
  FaExclamationTriangle,
  FaEdit,
  FaYoutube,
  FaLink,
  FaImage as FaImageIcon,
  FaStar,
  FaComments,
} from 'react-icons/fa';
import AppLayout from './AppLayout.jsx';
import Search from './Search.jsx';
import AcuerdoDetailsModal from './AcuerdoDetailsModal.jsx';

const EVENT_ACUERDO_PROPOSE_STEPS = [
  { title: 'Contexto', subtitle: 'Banda seleccionada y datos del evento' },
  { title: 'Descripción del acuerdo', subtitle: 'Explica con claridad la propuesta (obligatorio)' },
  { title: 'Precio y notas', subtitle: 'Importe y aclaraciones opcionales' },
  { title: 'Resumen y envío', subtitle: 'Confirma antes de enviar la solicitud' },
];

const EventDetails = ({ userType = 'cofradia' }) => {
  const navigate = useNavigate();
  const { eventId } = useParams();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const tabParam = searchParams.get('tab');
  const initialTab = tabParam === 'buscar' ? 1 : 0;
  const [activeTab, setActiveTab] = useState(initialTab);
  /** Vista desde Mensajes: oculta notas internas de la entidad. */
  const bandaVistaResumidaDesdeChat =
    userType === 'banda' && searchParams.get('desde') === 'chat';
  const { profile } = useAuth();
  
  const cardBg = useColorModeValue('white', 'gray.800');
  const textColor = useColorModeValue('gray.600', 'gray.400');
  const editModalCanvasBg = useColorModeValue('gray.50', 'gray.900');
  const editModalPanelBg = useColorModeValue('white', 'gray.800');
  const editModalPanelBorder = useColorModeValue('gray.100', 'gray.700');
  const editModalLabelColor = useColorModeValue('gray.700', 'gray.200');
  const editModalSwitchRowBg = useColorModeValue('purple.50', 'whiteAlpha.50');
  const editModalSwitchRowBorder = useColorModeValue('purple.100', 'whiteAlpha.200');
  const editModalFooterBg = useColorModeValue('white', 'gray.800');
  const editModalSuggestHoverBg = useColorModeValue('purple.50', 'whiteAlpha.100');
  const acuerdoCardBgAccepted = useColorModeValue('green.50', 'green.900');
  const acuerdoCardBgPending = useColorModeValue('orange.50', 'orange.900');
  const heroCardBorderColor = useColorModeValue('gray.200', 'gray.700');
  const heroFallbackBg = useColorModeValue('purple.50', 'gray.800');
  const heroTitleNoCartelColor = useColorModeValue('gray.800', 'white');
  const detailSurfaceBg = useColorModeValue('gray.50', 'gray.900');
  const detailSurfaceBorder = useColorModeValue('gray.100', 'gray.700');
  const detailSectionTitle = useColorModeValue('gray.800', 'gray.100');
  const detailLocationIconBg = useColorModeValue('purple.100', 'purple.900');
  const detailTimeIconBg = useColorModeValue('blue.50', 'blue.900');
  const shortlistFavCardBg = useColorModeValue('yellow.50', 'yellow.900');
  const disclaimerBoxBg = useColorModeValue('orange.50', 'orange.900');
  const disclaimerBoxBorder = useColorModeValue('orange.200', 'orange.700');
  const {
    open: isConfirmAcuerdoOpen,
    onOpen: onConfirmAcuerdoOpen,
    onClose: onConfirmAcuerdoCloseBase,
  } = useDisclosure();
  const { open: isCancelAcuerdoOpen, onOpen: onCancelAcuerdoOpen, onClose: onCancelAcuerdoClose } = useDisclosure();
  const { open: isAcuerdoDetailsOpen, onOpen: onAcuerdoDetailsOpen, onClose: onAcuerdoDetailsClose } = useDisclosure();
  const { open: isRespondAcuerdoOpen, onOpen: onRespondAcuerdoOpenBase, onClose: onRespondAcuerdoCloseBase } = useDisclosure();
  const onRespondAcuerdoOpen = useCallback(() => {
    setAceptaDisclaimerAceptarAcuerdo(false);
    setRespuestaNotas('');
    onRespondAcuerdoOpenBase();
  }, [onRespondAcuerdoOpenBase]);
  const onRespondAcuerdoClose = useCallback(() => {
    setAceptaDisclaimerAceptarAcuerdo(false);
    onRespondAcuerdoCloseBase();
  }, [onRespondAcuerdoCloseBase]);
  const { open: isRejectAcuerdoOpen, onOpen: onRejectAcuerdoOpen, onClose: onRejectAcuerdoClose } = useDisclosure();
  const { open: isRescindAcuerdoOpen, onOpen: onRescindAcuerdoOpen, onClose: onRescindAcuerdoClose } = useDisclosure();
  const { open: isDeleteEventoOpen, onOpen: onDeleteEventoOpen, onClose: onDeleteEventoClose } = useDisclosure();
  const { open: isEditEventoOpen, onOpen: onEditEventoOpen, onClose: onEditEventoClose } = useDisclosure();
  const { open: isReviewModalOpen, onOpen: onReviewModalOpen, onClose: onReviewModalClose } = useDisclosure();
  const [yaDejoResena, setYaDejoResena] = useState(false);
  const [eventoParaResenar, setEventoParaResenar] = useState(null);
  
  const [selectedBandaForAcuerdo, setSelectedBandaForAcuerdo] = useState(null);
  const [selectedBandaToCancel, setSelectedBandaToCancel] = useState(null);
  const [acuerdoData, setAcuerdoData] = useState({
    descripcion: '',
    precio: 0,
    notas: '',
  });
  const [acuerdoProposalStep, setAcuerdoProposalStep] = useState(0);
  const [acuerdoAceptaDisclaimer, setAcuerdoAceptaDisclaimer] = useState(false);
  const [aceptaDisclaimerAceptarAcuerdo, setAceptaDisclaimerAceptarAcuerdo] = useState(false);
  const [isSubmittingAcuerdoProposal, setIsSubmittingAcuerdoProposal] = useState(false);
  const [eventoAcuerdo, setEventoAcuerdo] = useState(null); // Acuerdo activo del evento
  const [eventoConversacionId, setEventoConversacionId] = useState(null);
  const [respuestaNotas, setRespuestaNotas] = useState('');
  const [rescindReason, setRescindReason] = useState('');
  const [isRespondingAcuerdo, setIsRespondingAcuerdo] = useState(false);
  const [isRescindingAcuerdo, setIsRescindingAcuerdo] = useState(false);
  const [cancelReason, setCancelReason] = useState('');
  const [isDeletingEvento, setIsDeletingEvento] = useState(false);
  const [isSavingEvento, setIsSavingEvento] = useState(false);
  
  const routePrefix = userType === 'banda' ? '/banda' : '/cofradia';
  
  // Estado para el shortlist de bandas
  const [eventShortlists, setEventShortlists] = useState({});
  const [bandaAcuerdosStatus, setBandaAcuerdosStatus] = useState({}); // { bandaId: { hasPendingAcuerdo: true/false, conversacionId: 'xxx' } }

  // Datos del evento
  const [evento, setEvento] = useState(location.state?.evento || {
    id: eventId || '',
    bandaId: null,
    bandaName: null,
    bandaAvatar: null,
    bandaUserId: null,
    cofradiaId: null,
    cofradiaUserId: null,
    eventName: 'Cargando...',
    description: '',
    date: '',
    timeStart: '',
    timeEnd: '',
    locationStart: '',
    locationEnd: '',
    sameLocation: true,
    latStart: null,
    lngStart: null,
    latEnd: null,
    lngEnd: null,
    status: 'pending',
    duration: '',
    notes: '',
    cartel: null,
    fotos: [],
    videos: [],
  });

  const [editEvent, setEditEvent] = useState({
    eventName: '',
    date: '',
    timeStart: '',
    timeEnd: '',
    locationStart: '',
    locationEnd: '',
    sameLocation: true,
    price: '',
    duration: '',
    notes: '',
  });
  const [editCartelFile, setEditCartelFile] = useState(null);
  const [editRemoveCartel, setEditRemoveCartel] = useState(false);
  const [editNewFotos, setEditNewFotos] = useState([]);
  const [editRemovedFotoUrls, setEditRemovedFotoUrls] = useState(new Set());
  const [editVideos, setEditVideos] = useState([]);
  const [editVideoDraft, setEditVideoDraft] = useState({ titulo: '', url: '' });
  const [editStartCoordinates, setEditStartCoordinates] = useState(null); // { lat, lng }
  const [editEndCoordinates, setEditEndCoordinates] = useState(null); // { lat, lng }
  const [editStartSuggestions, setEditStartSuggestions] = useState([]);
  const [editEndSuggestions, setEditEndSuggestions] = useState([]);
  const [showEditStartSuggestions, setShowEditStartSuggestions] = useState(false);
  const [showEditEndSuggestions, setShowEditEndSuggestions] = useState(false);
  const [isGeocodingEditStart, setIsGeocodingEditStart] = useState(false);
  const [isGeocodingEditEnd, setIsGeocodingEditEnd] = useState(false);
  const [editStartGeocodingError, setEditStartGeocodingError] = useState(null);
  const [editEndGeocodingError, setEditEndGeocodingError] = useState(null);

  const onConfirmAcuerdoClose = () => {
    setAcuerdoProposalStep(0);
    onConfirmAcuerdoCloseBase();
  };

  const computeDurationText = (start, end) => {
    const s = String(start || '').trim();
    const e = String(end || '').trim();
    if (!s || !e) return '';
    const [sh, sm] = s.split(':').map((x) => parseInt(x, 10));
    const [eh, em] = e.split(':').map((x) => parseInt(x, 10));
    if ([sh, sm, eh, em].some((n) => Number.isNaN(n))) return '';
    let mins = (eh * 60 + em) - (sh * 60 + sm);
    if (mins < 0) mins += 24 * 60;
    const h = Math.floor(mins / 60);
    const m = mins % 60;
    if (h <= 0 && m <= 0) return '';
    if (h > 0 && m > 0) return `${h}h ${m}min`;
    if (h > 0) return `${h}h`;
    return `${m}min`;
  };

  const normalizeEventVideos = (raw) => {
    if (raw == null) return [];
    let v = raw;
    if (typeof v === 'string') {
      const t = v.trim();
      if (!t) return [];
      try {
        v = JSON.parse(t);
      } catch {
        return [];
      }
    }
    if (Array.isArray(v)) {
      return v
        .map((item) => {
          if (!item || typeof item !== 'object') return null;
          const urlVal = item.url ?? item.link ?? item.href;
          if (typeof urlVal !== 'string' || !urlVal.trim()) return null;
          const out = { url: urlVal.trim() };
          if (typeof item.titulo === 'string' && item.titulo.trim()) out.titulo = item.titulo.trim();
          return out;
        })
        .filter(Boolean);
    }
    if (typeof v === 'object') {
      const urlVal = v.url ?? v.link ?? v.href;
      if (typeof urlVal === 'string' && urlVal.trim()) {
        const out = { url: urlVal.trim() };
        if (typeof v.titulo === 'string' && v.titulo.trim()) out.titulo = v.titulo.trim();
        return [out];
      }
    }
    return [];
  };

  const getYouTubeId = (url) => {
    if (!url || typeof url !== 'string') return null;
    const s = url.trim();
    if (!s) return null;
    try {
      const u = new URL(s);
      const host = u.hostname.toLowerCase();
      if (host === 'youtu.be' || host.endsWith('.youtu.be')) {
        const id = u.pathname.replace(/^\//, '').split('/')[0];
        return id || null;
      }
      if (host.includes('youtube.com') || host.includes('youtube-nocookie.com')) {
        const v = u.searchParams.get('v');
        if (v) return v;
        const parts = u.pathname.split('/').filter(Boolean);
        const shortsIndex = parts.findIndex((p) => p === 'shorts');
        if (shortsIndex >= 0 && parts[shortsIndex + 1]) return parts[shortsIndex + 1];
        const embedIndex = parts.findIndex((p) => p === 'embed');
        if (embedIndex >= 0 && parts[embedIndex + 1]) return parts[embedIndex + 1];
        const liveIndex = parts.findIndex((p) => p === 'live');
        if (liveIndex >= 0 && parts[liveIndex + 1]) return parts[liveIndex + 1];
      }
      return null;
    } catch {
      return null;
    }
  };

  const openEditModal = () => {
    setEditEvent({
      eventName: evento.eventName || '',
      date: evento.date || '',
      timeStart: evento.timeStart || '',
      timeEnd: evento.timeEnd || '',
      locationStart: evento.locationStart || '',
      locationEnd: evento.locationEnd || '',
      sameLocation: !!evento.sameLocation,
      duration: evento.duration || '',
      notes: evento.notes || '',
    });
    setEditStartCoordinates(
      evento.latStart != null && evento.lngStart != null ? { lat: evento.latStart, lng: evento.lngStart } : null,
    );
    setEditEndCoordinates(
      evento.sameLocation
        ? (evento.latStart != null && evento.lngStart != null ? { lat: evento.latStart, lng: evento.lngStart } : null)
        : (evento.latEnd != null && evento.lngEnd != null ? { lat: evento.latEnd, lng: evento.lngEnd } : null),
    );
    setEditStartSuggestions([]);
    setEditEndSuggestions([]);
    setShowEditStartSuggestions(false);
    setShowEditEndSuggestions(false);
    setIsGeocodingEditStart(false);
    setIsGeocodingEditEnd(false);
    setEditStartGeocodingError(null);
    setEditEndGeocodingError(null);
    setEditCartelFile(null);
    setEditRemoveCartel(false);
    setEditNewFotos([]);
    setEditRemovedFotoUrls(new Set());
    setEditVideos(normalizeEventVideos(evento.videos));
    setEditVideoDraft({ titulo: '', url: '' });
    onEditEventoOpen();
  };

  const loadEvento = async () => {
    if (!eventId) return;

    try {
      const response = await eventosAPI.getById(eventId);
      const eventoData = response.data;

      // Extraer shortlist del evento
      if (eventoData.shortlist && eventoData.shortlist.length > 0) {
        setEventShortlists({
          [eventId]: eventoData.shortlist.map((item) => ({
            id: item.banda.id,
            name: item.banda.nombre,
            avatar: item.banda.avatar,
            type: item.banda.tipoGrupo || 'banda',
            userId: item.banda.userId,
            location: '',
            distance: 0,
            trustedBy: 0,
          })),
        });
      }

      // Transformar datos
      setEvento({
        id: eventoData.id,
        eventName: eventoData.nombre,
        description: eventoData.descripcion || '',
        date: eventoData.fecha ? eventoData.fecha.split('T')[0] : '',
        timeStart: eventoData.horaInicio || eventoData.hora || '',
        timeEnd: eventoData.horaFin || '',
        locationStart: eventoData.ubicacionSalida || eventoData.ubicacion || '',
        locationEnd: eventoData.ubicacionEntrada || '',
        sameLocation: !!(eventoData.ubicacionEntrada && (eventoData.ubicacionEntrada === (eventoData.ubicacionSalida || eventoData.ubicacion))),
        latStart: eventoData.latSalida ?? eventoData.lat ?? null,
        lngStart: eventoData.lngSalida ?? eventoData.lng ?? null,
        latEnd: eventoData.latEntrada ?? null,
        lngEnd: eventoData.lngEntrada ?? null,
        status: eventoData.status?.toLowerCase() || 'pending',
        price: eventoData.precio || 0,
        duration: eventoData.duracion || '',
        notes: eventoData.notas || '',
        bandaId: eventoData.bandaId,
        bandaName: eventoData.banda?.nombre,
        bandaAvatar: eventoData.banda?.avatar,
        bandaUserId: eventoData.banda?.userId ?? null,
        cofradiaId: eventoData.cofradiaId,
        cofradiaName: eventoData.cofradia?.nombre,
        cofradiaAvatar: eventoData.cofradia?.avatar,
        cofradiaUserId: eventoData.cofradia?.userId ?? null,
        cartel: eventoData.cartel || null,
        fotos: Array.isArray(eventoData.fotos) ? eventoData.fotos : [],
        videos: normalizeEventVideos(eventoData.videos),
      });

      // Cargar estado de acuerdos para cada banda del shortlist
      if (eventoData.shortlist && eventoData.shortlist.length > 0 && userType === 'cofradia') {
        await loadAcuerdosStatus(eventId, eventoData.shortlist);
      }

      // Cargar acuerdo activo del evento (para bandas y cofradías)
      await loadEventoAcuerdo(eventId);
    } catch (error) {
      console.error('Error cargando evento:', error);
    }
  };

  // Cargar evento y shortlist desde API
  useEffect(() => {
    loadEvento();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [eventId]);

  useEffect(() => {
    const checkResena = async () => {
      if (!eventId) {
        setYaDejoResena(false);
        return;
      }
      try {
        const resenasResponse = await resenasAPI.getEscritas();
        const resenas = resenasResponse.data || [];
        setYaDejoResena(resenas.some((r) => r.evento?.id === eventId));
      } catch (error) {
        console.error('Error comprobando reseña del evento:', error);
        setYaDejoResena(false);
      }
    };
    checkResena();
  }, [eventId, userType]);

  const acuerdoBanda = eventoAcuerdo ? resolveBandaFromUser(eventoAcuerdo.confirmador) : null;
  const acuerdoCofradia = eventoAcuerdo ? resolveCofradiaFromUser(eventoAcuerdo.solicitante) : null;
  const acuerdoOtherName =
    userType === 'banda'
      ? acuerdoCofradia?.nombre ?? evento.cofradiaName
      : acuerdoBanda?.nombre ?? evento.bandaName;
  const acuerdoOtherAvatar =
    userType === 'banda'
      ? acuerdoCofradia?.avatar ?? evento.cofradiaAvatar
      : acuerdoBanda?.avatar ?? evento.bandaAvatar;

  const acuerdoOtherBandaId = userType === 'cofradia' ? (acuerdoBanda?.id ?? evento.bandaId) : null;
  const acuerdoOtherCofradiaId = userType === 'banda' ? (acuerdoCofradia?.id ?? evento.cofradiaId) : null;

  const goToAcuerdoOtherProfile = () => {
    if (userType === 'cofradia' && acuerdoOtherBandaId) {
      navigate(`/ver-perfil-banda?id=${acuerdoOtherBandaId}`);
    } else if (userType === 'banda' && acuerdoOtherCofradiaId) {
      navigate(`/ver-perfil-cofradia?id=${acuerdoOtherCofradiaId}`);
    }
  };

  const acuerdoOtherNameIsClickable =
    Boolean(acuerdoOtherName) && (Boolean(acuerdoOtherBandaId) || Boolean(acuerdoOtherCofradiaId));

  /** Cofradía: no mostrar shortlist en Detalles si ya hay acuerdo confirmado. */
  const showBandasFavoritasEnDetalle =
    userType === 'cofradia' &&
    eventShortlists[evento.id]?.length > 0 &&
    eventoAcuerdo?.status !== 'ACCEPTED';

  /** Una sola ficha (cartel + acuerdo + detalles) cuando el acuerdo ya está confirmado. */
  const fichaUnificadaAcuerdoConfirmado = eventoAcuerdo?.status === 'ACCEPTED';

  const eventoEfectivamenteFinalizado = isEventoEfectivamenteFinalizado(evento);
  const statusUi =
    eventoEfectivamenteFinalizado && evento.status !== 'cancelled' ? 'completed' : evento.status;
  const otraParteKey = userType === 'banda' ? 'cofradiaId' : 'bandaId';
  const puedeDejarResena =
    fichaUnificadaAcuerdoConfirmado &&
    eventoEfectivamenteFinalizado &&
    Boolean(evento[otraParteKey]) &&
    !yaDejoResena;

  const openReviewModal = () => {
    const eventoForReview = {
      id: evento.id,
      nombre: evento.eventName,
      fecha: evento.date,
    };
    if (userType === 'banda') {
      eventoForReview.cofradiaId = evento.cofradiaId;
      eventoForReview.cofradia = {
        id: evento.cofradiaId,
        nombre: evento.cofradiaName,
        avatar: evento.cofradiaAvatar,
      };
    } else {
      eventoForReview.bandaId = evento.bandaId;
      eventoForReview.banda = {
        id: evento.bandaId,
        nombre: evento.bandaName,
        avatar: evento.bandaAvatar,
      };
    }
    setEventoParaResenar(eventoForReview);
    onReviewModalOpen();
  };

  const handleReviewSubmitted = async () => {
    setYaDejoResena(true);
    try {
      const resenasResponse = await resenasAPI.getEscritas();
      const resenas = resenasResponse.data || [];
      setYaDejoResena(resenas.some((r) => r.evento?.id === eventId));
    } catch (error) {
      console.error('Error recargando reseñas:', error);
    }
  };

  const bandaEntidadNombre = evento.cofradiaName || acuerdoOtherName || '';
  const bandaEntidadClickable = Boolean(evento.cofradiaId);
  const goToBandaEntidadProfile = () => {
    if (evento.cofradiaId) navigate(`/ver-perfil-cofradia?id=${evento.cofradiaId}`);
  };
  const bandaPuedeAbrirChat = Boolean(eventoConversacionId || evento.cofradiaUserId);
  /** Banda contactada / en proceso: orientar al chat y al acuerdo. */
  const showBandaSiguientePaso =
    userType === 'banda' &&
    evento.status !== 'cancelled' &&
    !eventoEfectivamenteFinalizado &&
    eventoAcuerdo?.status !== 'ACCEPTED';

  // Autocomplete OpenStreetMap en edición (SALIDA)
  useEffect(() => {
    if (!isEditEventoOpen) return;
    const q = String(editEvent.locationStart || '').trim();
    if (q.length < 3) {
      setEditStartSuggestions([]);
      setShowEditStartSuggestions(false);
      setEditStartGeocodingError(null);
      return;
    }

    setIsGeocodingEditStart(true);
    setEditStartGeocodingError(null);

    const t = setTimeout(async () => {
      try {
        const response = await fetch(
          `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(q)}&limit=5&countrycodes=es`,
          { headers: { 'User-Agent': 'Cadencya/1.0' } },
        );
        const data = await response.json();
        if (Array.isArray(data) && data.length > 0) {
          const suggestions = data.map((item) => ({
            displayName: item.display_name,
            lat: parseFloat(item.lat),
            lng: parseFloat(item.lon),
          }));
          setEditStartSuggestions(suggestions);
          setShowEditStartSuggestions(true);
        } else {
          setEditStartSuggestions([]);
          setShowEditStartSuggestions(false);
          setEditStartGeocodingError('Ubicación no encontrada');
        }
      } catch (err) {
        console.error('Error buscando ubicaciones (edición salida):', err);
        setEditStartSuggestions([]);
        setShowEditStartSuggestions(false);
        setEditStartGeocodingError('Error al buscar ubicación');
      } finally {
        setIsGeocodingEditStart(false);
      }
    }, 450);

    return () => clearTimeout(t);
  }, [editEvent.locationStart, isEditEventoOpen, editEvent.sameLocation]);

  // Autocomplete OpenStreetMap en edición (ENTRADA)
  useEffect(() => {
    if (!isEditEventoOpen) return;
    if (editEvent.sameLocation) {
      setEditEndSuggestions([]);
      setShowEditEndSuggestions(false);
      setEditEndGeocodingError(null);
      setEditEndCoordinates(editStartCoordinates);
      return;
    }
    const q = String(editEvent.locationEnd || '').trim();
    if (q.length < 3) {
      setEditEndSuggestions([]);
      setShowEditEndSuggestions(false);
      setEditEndGeocodingError(null);
      return;
    }

    setIsGeocodingEditEnd(true);
    setEditEndGeocodingError(null);

    const t = setTimeout(async () => {
      try {
        const response = await fetch(
          `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(q)}&limit=5&countrycodes=es`,
          { headers: { 'User-Agent': 'Cadencya/1.0' } },
        );
        const data = await response.json();
        if (Array.isArray(data) && data.length > 0) {
          const suggestions = data.map((item) => ({
            displayName: item.display_name,
            lat: parseFloat(item.lat),
            lng: parseFloat(item.lon),
          }));
          setEditEndSuggestions(suggestions);
          setShowEditEndSuggestions(true);
        } else {
          setEditEndSuggestions([]);
          setShowEditEndSuggestions(false);
          setEditEndGeocodingError('Ubicación no encontrada');
        }
      } catch (err) {
        console.error('Error buscando ubicaciones (edición entrada):', err);
        setEditEndSuggestions([]);
        setShowEditEndSuggestions(false);
        setEditEndGeocodingError('Error al buscar ubicación');
      } finally {
        setIsGeocodingEditEnd(false);
      }
    }, 450);

    return () => clearTimeout(t);
  }, [editEvent.locationEnd, isEditEventoOpen, editEvent.sameLocation, editStartCoordinates]);

  // Duración: si hay hora final, se calcula automáticamente y queda read-only.
  useEffect(() => {
    if (!isEditEventoOpen) return;
    if (!editEvent.timeEnd) return;
    const computed = computeDurationText(editEvent.timeStart, editEvent.timeEnd);
    setEditEvent((p) => (p.duration === computed ? p : { ...p, duration: computed }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editEvent.timeStart, editEvent.timeEnd, isEditEventoOpen]);

  // Verificar si hay algún acuerdo activo (PENDING o ACCEPTED)
  const hasActiveAcuerdo = () => {
    return Object.values(bandaAcuerdosStatus).some(
      status => status.hasPendingAcuerdo && (status.acuerdoStatus === 'PENDING' || status.acuerdoStatus === 'ACCEPTED')
    );
  };

  // Cargar estado de acuerdos para las bandas del shortlist
  const loadEventoAcuerdo = async (eventoId) => {
    setEventoAcuerdo(null);
    setEventoConversacionId(null);
    try {
      const conversacionesResponse = await mensajesAPI.getConversaciones();
      const conversaciones = conversacionesResponse.data;
      const conversacionEvento = conversaciones.find((c) => c.evento?.id === eventoId);

      if (!conversacionEvento) return;

      setEventoConversacionId(conversacionEvento.id);

      try {
        const acuerdoResponse = await acuerdosAPI.getActive(conversacionEvento.id);
        const acuerdo = acuerdoResponse.data;
        if (acuerdo && (acuerdo.status === 'PENDING' || acuerdo.status === 'ACCEPTED')) {
          setEventoAcuerdo(acuerdo);
        }
      } catch (error) {
        console.log('No hay acuerdo activo para este evento');
      }
    } catch (error) {
      console.error('Error cargando acuerdo del evento:', error);
    }
  };

  const eventLocationLine =
    evento.sameLocation || !evento.locationEnd
      ? evento.locationStart
      : `${evento.locationStart} → ${evento.locationEnd}`;

  const sendAcuerdoChatNotice = async (conversacionId, text) => {
    if (!conversacionId || !String(text || '').trim()) return;
    try {
      await mensajesAPI.sendMensaje(conversacionId, text);
    } catch (e) {
      console.error('Error enviando mensaje al chat:', e);
    }
  };

  const confirmAcceptAcuerdoDetail = async () => {
    if (!eventoAcuerdo?.id) return;
    if (!aceptaDisclaimerAceptarAcuerdo) {
      toaster.create({
        title: 'Aviso legal obligatorio',
        description: 'Debes aceptar el aviso legal antes de aceptar el acuerdo.',
        type: 'warning',
        duration: 5000,
        closable: true,
      });
      return;
    }
    setIsRespondingAcuerdo(true);
    try {
      await acuerdosAPI.respond(eventoAcuerdo.id, {
        accept: true,
        respuestaNotas: respuestaNotas || undefined,
      });
      let mensajeAceptacion = '✅ He aceptado el acuerdo.';
      if (respuestaNotas) mensajeAceptacion += `\n\n📝 Notas: ${respuestaNotas}`;
      await sendAcuerdoChatNotice(eventoConversacionId, mensajeAceptacion);
      toaster.create({
        title: '¡Acuerdo aceptado!',
        description:
          userType === 'banda'
            ? 'El evento queda confirmado. La fecha se ha reservado en tu calendario de disponibilidad y tienes una nueva actuación en Gestión (Actuaciones) para completar ficha y formación.'
            : 'Has aceptado el acuerdo. El evento se ha confirmado.',
        type: 'success',
        duration: 8000,
        closable: true,
      });
      onRespondAcuerdoClose();
      setRespuestaNotas('');
      setAceptaDisclaimerAceptarAcuerdo(false);
      await loadEvento();
    } catch (error) {
      console.error('Error aceptando acuerdo:', error);
      toaster.create({
        title: 'Error',
        description: error.response?.data?.message || 'Error al aceptar el acuerdo',
        type: 'error',
        duration: 5000,
        closable: true,
      });
    } finally {
      setIsRespondingAcuerdo(false);
    }
  };

  const confirmRejectAcuerdoDetail = async () => {
    if (!eventoAcuerdo?.id) return;
    setIsRespondingAcuerdo(true);
    try {
      await acuerdosAPI.respond(eventoAcuerdo.id, {
        accept: false,
        respuestaNotas: respuestaNotas || undefined,
      });
      let mensajeRechazo = '❌ He rechazado el acuerdo.';
      if (respuestaNotas) mensajeRechazo += `\n\n📝 Motivo: ${respuestaNotas}`;
      await sendAcuerdoChatNotice(eventoConversacionId, mensajeRechazo);
      toaster.create({
        title: 'Acuerdo rechazado',
        description: 'Has rechazado el acuerdo.',
        type: 'info',
        duration: 5000,
        closable: true,
      });
      onRejectAcuerdoClose();
      setRespuestaNotas('');
      await loadEvento();
    } catch (error) {
      console.error('Error rechazando acuerdo:', error);
      toaster.create({
        title: 'Error',
        description: error.response?.data?.message || 'Error al rechazar el acuerdo',
        type: 'error',
        duration: 5000,
        closable: true,
      });
    } finally {
      setIsRespondingAcuerdo(false);
    }
  };

  const confirmRescindAcuerdoDetail = async () => {
    if (!eventoAcuerdo?.id) return;
    setIsRescindingAcuerdo(true);
    try {
      await acuerdosAPI.rescind(eventoAcuerdo.id, rescindReason || undefined);
      const mensajeRescision = rescindReason
        ? `⚠️ He rescindido el acuerdo.\n\nMotivo: ${rescindReason}`
        : `⚠️ He rescindido el acuerdo.`;
      await sendAcuerdoChatNotice(eventoConversacionId, mensajeRescision);
      toaster.create({
        title: 'Acuerdo rescindido',
        description: 'Has rescindido el acuerdo. El evento volverá a estado pendiente.',
        type: 'info',
        duration: 6000,
        closable: true,
      });
      onRescindAcuerdoClose();
      setRescindReason('');
      await loadEvento();
    } catch (error) {
      console.error('Error rescindiendo acuerdo:', error);
      toaster.create({
        title: 'Error',
        description: error.response?.data?.message || 'Error al rescindir el acuerdo',
        type: 'error',
        duration: 5000,
        closable: true,
      });
    } finally {
      setIsRescindingAcuerdo(false);
    }
  };

  const goToAcuerdoChat = () => {
    if (eventoConversacionId) {
      navigate(`${routePrefix}/mensajes?conversacion=${eventoConversacionId}`);
      return;
    }
    const otherId = userType === 'banda' ? evento.cofradiaUserId : evento.bandaUserId;
    if (otherId) {
      navigate(`${routePrefix}/mensajes?contact=${otherId}`);
      return;
    }
    navigate(`${routePrefix}/mensajes`);
  };

  const loadAcuerdosStatus = async (eventoId, shortlist) => {
    try {
      // Obtener todas las conversaciones
      const conversacionesResponse = await mensajesAPI.getConversaciones();
      const conversaciones = conversacionesResponse.data;
      
      const statusMap = {};
      
      // Para cada banda en el shortlist, verificar si hay una conversación y un acuerdo pendiente
      for (const item of shortlist) {
        const bandaId = item.banda.id;
        const bandaUserId = item.banda.userId;
        
        // Buscar conversación asociada a este evento y esta banda
        const conversacion = conversaciones.find(c => 
          c.evento?.id === eventoId && 
          c.participantes.some(p => p.userId === bandaUserId)
        );
        
        if (conversacion) {
          // Verificar si hay un acuerdo pendiente o aceptado en esta conversación
          try {
            const acuerdoResponse = await acuerdosAPI.getActive(conversacion.id);
            const acuerdo = acuerdoResponse.data;
            
            statusMap[bandaId] = {
              hasPendingAcuerdo: acuerdo && (acuerdo.status === 'PENDING' || acuerdo.status === 'ACCEPTED'),
              conversacionId: conversacion.id,
              acuerdoStatus: acuerdo?.status,
            };
          } catch (error) {
            // No hay acuerdo activo
            statusMap[bandaId] = {
              hasPendingAcuerdo: false,
              conversacionId: conversacion.id,
            };
          }
        } else {
          statusMap[bandaId] = {
            hasPendingAcuerdo: false,
            conversacionId: null,
          };
        }
      }
      
      setBandaAcuerdosStatus(statusMap);
    } catch (error) {
      console.error('Error cargando estado de acuerdos:', error);
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'confirmed': return 'green';
      case 'pending': return 'orange';
      case 'completed': return 'blue';
      case 'cancelled': return 'red';
      default: return 'gray';
    }
  };

  const getStatusText = (status) => {
    switch (status) {
      case 'confirmed': return 'Confirmado';
      case 'pending': return 'Pendiente';
      case 'completed': return 'Completado';
      case 'cancelled': return 'Cancelado';
      default: return 'Desconocido';
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'confirmed': return FaCheckCircle;
      case 'pending': return FaHourglass;
      case 'completed': return FaCheckCircle;
      case 'cancelled': return FaInfoCircle;
      default: return FaInfoCircle;
    }
  };

  const handleSaveEditEvento = async () => {
    setIsSavingEvento(true);
    try {
      const payload = {
        nombre: editEvent.eventName,
        fecha: editEvent.date,
        horaInicio: editEvent.timeStart,
        horaFin: editEvent.timeEnd || null,
        ubicacionSalida: editEvent.locationStart,
        ubicacionEntrada: editEvent.sameLocation ? editEvent.locationStart : (editEvent.locationEnd || null),
        latSalida: editStartCoordinates?.lat ?? null,
        lngSalida: editStartCoordinates?.lng ?? null,
        latEntrada: editEvent.sameLocation ? (editStartCoordinates?.lat ?? null) : (editEndCoordinates?.lat ?? null),
        lngEntrada: editEvent.sameLocation ? (editStartCoordinates?.lng ?? null) : (editEndCoordinates?.lng ?? null),
        duracion: editEvent.timeEnd ? computeDurationText(editEvent.timeStart, editEvent.timeEnd) : editEvent.duration,
        notas: editEvent.notes,
        videos: editVideos && editVideos.length > 0 ? editVideos : [],
      };

      await eventosAPI.update(evento.id, payload);

      // Cartel: borrar si se solicita
      if (editRemoveCartel && evento.cartel) {
        await eventosAPI.deleteCartel(evento.id);
      }
      // Cartel: subir si hay nuevo
      if (editCartelFile) {
        await eventosAPI.uploadCartel(evento.id, editCartelFile);
      }

      // Galería: eliminar URLs marcadas
      if (editRemovedFotoUrls && editRemovedFotoUrls.size > 0) {
        for (const url of editRemovedFotoUrls.values()) {
          // eslint-disable-next-line no-await-in-loop
          await eventosAPI.deleteFoto(evento.id, url);
        }
      }
      // Galería: añadir nuevas fotos
      if (editNewFotos && editNewFotos.length > 0) {
        await eventosAPI.uploadFotos(evento.id, editNewFotos);
      }

      toaster.create({
        title: 'Evento actualizado',
        type: 'success',
        duration: 3500,
        closable: true,
      });

      onEditEventoClose();
      await loadEvento();
    } catch (error) {
      console.error('Error actualizando evento:', error);
      toaster.create({
        title: 'Error al guardar cambios',
        description: error.response?.data?.message || 'No se pudo actualizar el evento. Inténtalo de nuevo.',
        type: 'error',
        duration: 6000,
        closable: true,
      });
    } finally {
      setIsSavingEvento(false);
    }
  };

  const handleAddToShortlist = async (banda, mensaje = '') => {
    const currentEventId = evento.id;
    const currentShortlist = eventShortlists[currentEventId] || [];
    
    // Evitar duplicados
    if (currentShortlist.some(b => b.id === banda.id)) {
      return;
    }
    
    try {
      // 1. Crear o buscar conversación existente
      let conversacionId;
      try {
        const conversacionResponse = await mensajesAPI.createConversacion(
          banda.userId,
          currentEventId
        );
        conversacionId = conversacionResponse.data.id;
      } catch (error) {
        // Si ya existe la conversación, obtener su ID del error o buscarla
        if (error.response?.data?.conversacionId) {
          conversacionId = error.response.data.conversacionId;
        } else {
          throw error;
        }
      }

      // 2. Si hay mensaje, enviarlo
      if (mensaje && conversacionId) {
        await mensajesAPI.sendMensaje(conversacionId, mensaje);
      }

      // 3. Llamar al API para añadir al shortlist
      const response = await eventosAPI.addToShortlist(currentEventId, banda.id, {
        openedChatWithMessage: Boolean(mensaje && String(mensaje).trim()),
      });
      
      // 4. Actualizar estado local con los datos completos del backend (incluyendo userId)
      setEventShortlists(prev => ({
        ...prev,
        [currentEventId]: [...(prev[currentEventId] || []), {
          id: response.data.banda.id,
          name: response.data.banda.nombre,
          avatar: response.data.banda.avatar,
          type: response.data.banda.tipoGrupo || 'banda',
          userId: response.data.banda.userId,
          location: banda.location || '',
          distance: banda.distance || 0,
          trustedBy: banda.trustedBy || 0,
          conversacionId: conversacionId, // Guardar el ID de la conversación
        }]
      }));
      
      toaster.create({
        title: mensaje ? '¡Mensaje enviado!' : 'Añadida a favoritas',
        description: mensaje 
          ? 'Se ha enviado tu mensaje y la banda ha sido añadida a favoritas.'
          : 'La banda ha sido añadida a favoritas. Podrás escribirle cuando quieras desde Mensajes.',
        type: 'success',
        duration: 5000,
        closable: true,
      });
      
      console.log(`Banda ${banda.name || banda.nombre} añadida al shortlist del evento ${currentEventId}`);
    } catch (error) {
      console.error('Error añadiendo al shortlist:', error);
      toaster.create({
        title: 'Error',
        description: error.response?.data?.message || 'Error al contactar con la banda',
        type: 'error',
        duration: 5000,
        closable: true,
      });
    }
  };

  const handleRemoveFromShortlist = async (eventId, bandaId) => {
    try {
      // Llamar al API para eliminar del shortlist
      await eventosAPI.removeFromShortlist(eventId, bandaId);
      
      // Actualizar estado local
      setEventShortlists(prev => {
        const currentShortlist = prev[eventId] || [];
        return {
          ...prev,
          [eventId]: currentShortlist.filter(b => b.id !== bandaId)
        };
      });
      
      console.log(`Banda ${bandaId} eliminada del shortlist del evento ${eventId}`);
    } catch (error) {
      console.error('Error eliminando del shortlist:', error);
      toaster.create({
        title: 'Error',
        description: error.response?.data?.message || 'Error al eliminar la banda del shortlist',
        type: 'error',
        duration: 5000,
        closable: true,
      });
    }
  };

  const handleCancelAcuerdo = (banda) => {
    setSelectedBandaToCancel(banda);
    onCancelAcuerdoOpen();
  };

  const handleConfirmCancelAcuerdo = async () => {
    if (!selectedBandaToCancel) return;

    try {
      const bandaStatus = bandaAcuerdosStatus[selectedBandaToCancel.id];
      if (!bandaStatus?.conversacionId) {
        throw new Error('No se encontró la conversación asociada');
      }

      // Obtener el acuerdo activo para obtener su ID
      const acuerdoResponse = await acuerdosAPI.getActive(bandaStatus.conversacionId);
      const acuerdo = acuerdoResponse.data;

      if (!acuerdo) {
        throw new Error('No se encontró un acuerdo activo');
      }

      // Cancelar el acuerdo
      await acuerdosAPI.cancel(acuerdo.id);
      
      // Enviar mensaje al chat notificando la cancelación
      const mensajeCancelacion = '🚫 He cancelado la propuesta de acuerdo.';
      
      try {
        await mensajesAPI.sendMensaje(bandaStatus.conversacionId, mensajeCancelacion);
        console.log('Mensaje de cancelación enviado al chat');
      } catch (error) {
        console.error('Error enviando mensaje de cancelación:', error);
      }

      // Actualizar el estado local
      setBandaAcuerdosStatus(prev => ({
        ...prev,
        [selectedBandaToCancel.id]: {
          ...prev[selectedBandaToCancel.id],
          hasPendingAcuerdo: false,
          acuerdoStatus: null,
        }
      }));

      onCancelAcuerdoClose();
      setSelectedBandaToCancel(null);

      toaster.create({
        title: 'Acuerdo cancelado',
        description: `El acuerdo con ${selectedBandaToCancel.name} ha sido cancelado.`,
        type: 'info',
        duration: 5000,
        closable: true,
      });
    } catch (error) {
      console.error('Error cancelando acuerdo:', error);
      toaster.create({
        title: 'Error',
        description: error.response?.data?.message || 'Error al cancelar el acuerdo',
        type: 'error',
        duration: 5000,
        closable: true,
      });
    }
  };

  const handleDeleteEvento = async () => {
    if (!cancelReason.trim()) {
      toaster.create({
        title: 'Motivo requerido',
        description: 'Por favor, indica el motivo de la cancelación',
        type: 'warning',
        duration: 3000,
        closable: true,
      });
      return;
    }

    setIsDeletingEvento(true);
    try {
      await eventosAPI.delete(eventId, cancelReason);
      
      toaster.create({
        title: 'Evento cancelado',
        description: 'El evento ha sido cancelado y se han notificado a todos los participantes.',
        type: 'success',
        duration: 5000,
        closable: true,
      });

      onDeleteEventoClose();
      // Navegar a la lista de eventos
      navigate(`${routePrefix}/eventos`);
    } catch (error) {
      console.error('Error eliminando evento:', error);
      toaster.create({
        title: 'Error',
        description: error.response?.data?.message || 'Error al cancelar el evento',
        type: 'error',
        duration: 5000,
        closable: true,
      });
    } finally {
      setIsDeletingEvento(false);
    }
  };

  const handleSelectBandaForAcuerdo = (banda) => {
    setSelectedBandaForAcuerdo({ banda, evento });
    setAcuerdoProposalStep(0);
    setAcuerdoAceptaDisclaimer(false);
    // Inicializar datos del acuerdo con información del evento
    setAcuerdoData({
      descripcion: `Propuesta de acuerdo para el evento "${evento.eventName}"`,
      precio: evento.price || 0,
      notas: evento.notes || '',
    });
    onConfirmAcuerdoOpen();
  };

  const canAdvanceAcuerdoProposalStep = (stepIdx) => {
    if (stepIdx === 0) return true;
    if (stepIdx === 1) return String(acuerdoData.descripcion || '').trim().length > 0;
    if (stepIdx === 2) return true;
    if (stepIdx === 3) return String(acuerdoData.descripcion || '').trim().length > 0 && acuerdoAceptaDisclaimer;
    return true;
  };

  const handleConfirmAcuerdo = async () => {
    if (!selectedBandaForAcuerdo) return;
    if (!acuerdoAceptaDisclaimer) {
      toaster.create({
        title: 'Aviso legal obligatorio',
        description: 'Debes aceptar el aviso legal para proponer el acuerdo.',
        type: 'warning',
        duration: 5000,
        closable: true,
      });
      return;
    }

    const { banda } = selectedBandaForAcuerdo;

    setIsSubmittingAcuerdoProposal(true);
    try {
      // 1. Crear o obtener conversación con la banda
      let conversacion;
      try {
        conversacion = await mensajesAPI.createConversacion(banda.userId, evento.id);
      } catch (error) {
        // Si la conversación ya existe, obtenerla de las conversaciones existentes
        if (error.response?.data?.message?.includes('ya existe')) {
          const conversaciones = await mensajesAPI.getConversaciones();
          conversacion = conversaciones.data.find(c => 
            c.evento?.id === evento.id && 
            c.participantes.some(p => p.user?.banda?.id === banda.id)
          );
          if (!conversacion) throw error;
        } else {
          throw error;
        }
      }
      
      // 2. Crear solicitud de acuerdo con los datos del formulario
      const conversacionId = conversacion.data?.id || conversacion.id;
      
      await acuerdosAPI.create({
        conversacionId: conversacionId,
        descripcion: acuerdoData.descripcion,
        fecha: evento.date,
        precio: acuerdoData.precio,
        notas: acuerdoData.notas,
        aceptaDisclaimer: true,
      });
      
      // 3. Enviar mensaje al chat notificando la propuesta
      let mensajePropuesta = '🤝 He propuesto un acuerdo para este evento.';
      if (acuerdoData.precio) {
        mensajePropuesta += `\n\n💰 Precio propuesto: ${acuerdoData.precio}€`;
      }
      if (acuerdoData.descripcion) {
        mensajePropuesta += `\n\n📋 Descripción: ${acuerdoData.descripcion}`;
      }
      if (acuerdoData.notas) {
        mensajePropuesta += `\n\n📝 Notas: ${acuerdoData.notas}`;
      }
      
      try {
        await mensajesAPI.sendMensaje(conversacionId, mensajePropuesta);
        console.log('Mensaje de propuesta enviado al chat');
      } catch (error) {
        console.error('Error enviando mensaje de propuesta:', error);
      }
      
      console.log('Acuerdo propuesto a la banda:', banda.name, 'para evento:', evento.eventName);
      
      // El evento permanece en estado PENDING hasta que la banda acepte
      
      onConfirmAcuerdoClose();
      setSelectedBandaForAcuerdo(null);
      
      toaster.create({
        title: '¡Propuesta enviada!',
        description: `Se ha enviado la propuesta de acuerdo a ${banda.name}. El evento permanecerá pendiente hasta que la banda acepte.`,
        type: 'success',
        duration: 6000,
        closable: true,
      });
      
      // Navegar a mensajes con el ID de la conversación para seleccionarla automáticamente
      navigate(`${routePrefix}/mensajes?conversacion=${conversacionId}`);
    } catch (error) {
      console.error('Error proponiendo acuerdo:', error);
      toaster.create({
        title: 'Error',
        description: error.response?.data?.message || 'Error al proponer el acuerdo',
        type: 'error',
        duration: 5000,
        closable: true,
      });
    } finally {
      setIsSubmittingAcuerdoProposal(false);
    }
  };

  const getShortlistedIds = (eventId) => {
    const shortlist = eventShortlists[eventId] || [];
    return shortlist.map(b => b.id);
  };

  return (
    <AppLayout userType={userType} userName={getPerfilDisplayName(profile, userType)}>
      <Box bg={detailSurfaceBg} minH="100vh" py={{ base: 4, md: 8 }}>
        <Container maxW="7xl">
          <VStack gap={6} align="stretch">
            {/* Breadcrumb */}
            <Breadcrumb.Root>
              <Breadcrumb.List gap={2}>
                <Breadcrumb.Item>
                  <Breadcrumb.Link onClick={() => navigate(`${routePrefix}/eventos`)}>
                    Eventos
                  </Breadcrumb.Link>
                </Breadcrumb.Item>
                <Breadcrumb.Separator>{<Icon as={FaChevronRight} color="gray.500" />}</Breadcrumb.Separator><Breadcrumb.Item>
                  <Breadcrumb.Link fontWeight="600">{evento.eventName}</Breadcrumb.Link>
                </Breadcrumb.Item>
              </Breadcrumb.List>
            </Breadcrumb.Root>

            {!fichaUnificadaAcuerdoConfirmado && (
              <>
                <Box
                  position="sticky"
                  top={0}
                  zIndex={10}
                  bg={detailSurfaceBg}
                  pb={4}
                >
                  <Card.Root bg={cardBg} shadow="lg" rounded="2xl">
                    <Card.Body p={{ base: 4, md: 6 }}>
                      <HStack justify="space-between" flexWrap="wrap" gap={4}>
                        <VStack align="start" gap={2} flex={1}>
                          <HStack gap={3} flexWrap="wrap">
                            <Button
                              variant="ghost"
                              size="sm"
                              onClick={() => navigate(`${routePrefix}/eventos`)}><Icon as={FaArrowLeft} />Volver
                                                          </Button>
                            <Badge
                              colorPalette={getStatusColor(statusUi)}
                              fontSize="sm"
                              px={3}
                              py={1}
                              rounded="full"
                            >
                              <Icon as={getStatusIcon(statusUi)} mr={1} />
                              {getStatusText(statusUi)}
                            </Badge>
                          </HStack>
                          <Heading size={{ base: 'md', md: 'lg' }}>{evento.eventName}</Heading>
                          {userType === 'banda' && bandaEntidadNombre ? (
                            <HStack
                              gap={2}
                              align="center"
                              as={bandaEntidadClickable ? 'button' : 'div'}
                              type={bandaEntidadClickable ? 'button' : undefined}
                              cursor={bandaEntidadClickable ? 'pointer' : 'default'}
                              onClick={bandaEntidadClickable ? goToBandaEntidadProfile : undefined}
                              textAlign="left"
                              _hover={
                                bandaEntidadClickable
                                  ? { opacity: 0.85 }
                                  : undefined
                              }
                            >
                              <Avatar.Root size="sm" bg="purple.100" color="purple.700">
                                <Avatar.Fallback name={bandaEntidadNombre}>
                                  <Icon as={FaChurch} />
                                </Avatar.Fallback>
                                <Avatar.Image src={evento.cofradiaAvatar || acuerdoOtherAvatar} />
                              </Avatar.Root>
                              <VStack align="start" gap={0} minW={0}>
                                <Text fontSize="xs" color="gray.500" fontWeight="600" textTransform="uppercase" letterSpacing="0.04em">
                                  Entidad religiosa
                                </Text>
                                <Text fontSize="sm" fontWeight="700" color="purple.700" lineClamp={1}>
                                  {bandaEntidadNombre}
                                </Text>
                              </VStack>
                            </HStack>
                          ) : null}
                          <HStack gap={4} flexWrap="wrap" fontSize={{ base: 'xs', md: 'sm' }}>
                            <HStack gap={2}>
                              <Icon as={FaCalendarCheck} color="purple.500" boxSize={{ base: 3, md: 4 }} />
                              <Text fontSize={{ base: 'xs', md: 'sm' }} color={textColor}>
                                {new Date(evento.date).toLocaleDateString('es-ES', {
                                  weekday: 'long',
                                  day: 'numeric',
                                  month: 'long',
                                  year: 'numeric',
                                })}
                              </Text>
                            </HStack>
                            <HStack gap={2}>
                              <Icon as={FaClock} color="blue.500" boxSize={{ base: 3, md: 4 }} />
                              <Text fontSize={{ base: 'xs', md: 'sm' }} color={textColor}>
                                {evento.timeEnd ? `${evento.timeStart} - ${evento.timeEnd}` : evento.timeStart}
                              </Text>
                            </HStack>
                            <HStack gap={2}>
                              <Icon as={FaMapMarkerAlt} color="red.500" boxSize={{ base: 3, md: 4 }} />
                              <Text fontSize={{ base: 'xs', md: 'sm' }} color={textColor} lineClamp={1}>
                                {evento.sameLocation || !evento.locationEnd
                                  ? evento.locationStart
                                  : `${evento.locationStart} → ${evento.locationEnd}`}
                              </Text>
                            </HStack>
                          </HStack>
                        </VStack>

                        <HStack gap={2}>
                          {userType === 'cofradia' &&
                            evento.status !== 'cancelled' &&
                            !eventoEfectivamenteFinalizado &&
                            !hasActiveAcuerdo() && (
                              <Button
                                variant="outline"
                                colorPalette="purple"
                                onClick={openEditModal}
                                size={{ base: 'sm', md: 'md' }}><Icon as={FaEdit} />Editar
                                                              </Button>
                            )}
                          {userType === 'cofradia' &&
                            evento.status !== 'cancelled' &&
                            !eventoEfectivamenteFinalizado && (
                            <Tooltip content="Cancelar evento" showArrow>
                              <IconButton
                                colorPalette="red"
                                variant="outline"
                                onClick={onDeleteEventoOpen}
                                size={{ base: 'sm', md: 'md' }}
                                aria-label="Eliminar evento"><Icon as={FaTrash} /></IconButton>
                            </Tooltip>
                          )}
                        </HStack>
                      </HStack>
                    </Card.Body>
                  </Card.Root>
                </Box>

                {eventoAcuerdo && !fichaUnificadaAcuerdoConfirmado && (
                  <Card.Root
                    bg={eventoAcuerdo.status === 'ACCEPTED' ? acuerdoCardBgAccepted : acuerdoCardBgPending}
                    shadow="lg"
                    rounded="2xl"
                    borderWidth="2px"
                    borderColor={eventoAcuerdo.status === 'ACCEPTED' ? 'green.400' : 'orange.400'}
                  >
                    <Card.Body>
                      <VStack gap={4} align="stretch">
                        <HStack justify="space-between" flexWrap="wrap" gap={2}>
                          <HStack gap={3}>
                            <Icon
                              as={eventoAcuerdo.status === 'ACCEPTED' ? FaCheckCircle : FaHandshake}
                              color={eventoAcuerdo.status === 'ACCEPTED' ? 'green.600' : 'orange.600'}
                              boxSize={6}
                            />
                            <Heading size="md" color={eventoAcuerdo.status === 'ACCEPTED' ? 'green.800' : 'orange.800'}>
                              {eventoAcuerdo.status === 'ACCEPTED' ? 'Acuerdo Confirmado' : 'Acuerdo Propuesto'}
                            </Heading>
                          </HStack>
                          <Badge
                            colorPalette={eventoAcuerdo.status === 'ACCEPTED' ? 'green' : 'orange'}
                            fontSize="md"
                            px={3}
                            py={1}
                            rounded="full"
                          >
                            {eventoAcuerdo.status === 'ACCEPTED' ? 'Confirmado' : 'Pendiente'}
                          </Badge>
                        </HStack>

                        <Separator borderColor={eventoAcuerdo.status === 'ACCEPTED' ? 'green.300' : 'orange.300'} />

                        <HStack gap={4} align="center">
                          <Avatar.Root size="lg"><Avatar.Fallback name={acuerdoOtherName}>{<Icon as={userType === 'banda' ? FaChurch : FaMusic} />}</Avatar.Fallback><Avatar.Image src={acuerdoOtherAvatar} /></Avatar.Root>
                          <VStack align="start" gap={0} flex={1}>
                            <Text
                              as={acuerdoOtherNameIsClickable ? 'button' : 'span'}
                              fontSize="lg"
                              fontWeight="bold"
                              color={eventoAcuerdo.status === 'ACCEPTED' ? 'green.900' : 'orange.900'}
                              cursor={acuerdoOtherNameIsClickable ? 'pointer' : 'default'}
                              textAlign="left"
                              onClick={acuerdoOtherNameIsClickable ? goToAcuerdoOtherProfile : undefined}
                              _hover={
                                acuerdoOtherNameIsClickable
                                  ? { textDecoration: 'underline', color: 'purple.600' }
                                  : undefined
                              }
                            >
                              {acuerdoOtherName}
                            </Text>
                            <Text fontSize="sm" color={eventoAcuerdo.status === 'ACCEPTED' ? 'green.700' : 'orange.700'}>
                              {userType === 'banda' ? 'Cofradía' : 'Banda'}
                            </Text>
                          </VStack>
                        </HStack>

                        <Separator borderColor={eventoAcuerdo.status === 'ACCEPTED' ? 'green.300' : 'orange.300'} />

                        <SimpleGrid columns={{ base: 1, md: 2 }} gap={4}>
                          {eventoAcuerdo.precio && (
                            <HStack gap={3} align="start">
                              <Icon
                                as={FaEuroSign}
                                color={eventoAcuerdo.status === 'ACCEPTED' ? 'green.600' : 'orange.600'}
                                boxSize={5}
                                mt={1}
                              />
                              <VStack gap={0} align="start" flex={1}>
                                <Text fontSize="xs" fontWeight="medium" color={eventoAcuerdo.status === 'ACCEPTED' ? 'green.700' : 'orange.700'}>
                                  Precio
                                </Text>
                                <Text fontSize="lg" fontWeight="bold" color={eventoAcuerdo.status === 'ACCEPTED' ? 'green.900' : 'orange.900'}>
                                  {eventoAcuerdo.precio}€
                                </Text>
                              </VStack>
                            </HStack>
                          )}

                          {eventoAcuerdo.descripcion && (
                            <HStack gap={3} align="start">
                              <Icon
                                as={FaFileAlt}
                                color={eventoAcuerdo.status === 'ACCEPTED' ? 'green.600' : 'orange.600'}
                                boxSize={5}
                                mt={1}
                              />
                              <VStack gap={0} align="start" flex={1}>
                                <Text fontSize="xs" fontWeight="medium" color={eventoAcuerdo.status === 'ACCEPTED' ? 'green.700' : 'orange.700'}>
                                  Descripción
                                </Text>
                                <Text
                                  fontSize="sm"
                                  color={eventoAcuerdo.status === 'ACCEPTED' ? 'green.800' : 'orange.800'}
                                  lineClamp={2}
                                >
                                  {eventoAcuerdo.descripcion}
                                </Text>
                              </VStack>
                            </HStack>
                          )}

                          {eventoAcuerdo.notas && (
                            <HStack gap={3} align="start">
                              <Icon
                                as={FaStickyNote}
                                color={eventoAcuerdo.status === 'ACCEPTED' ? 'green.600' : 'orange.600'}
                                boxSize={5}
                                mt={1}
                              />
                              <VStack gap={0} align="start" flex={1}>
                                <Text fontSize="xs" fontWeight="medium" color={eventoAcuerdo.status === 'ACCEPTED' ? 'green.700' : 'orange.700'}>
                                  Notas
                                </Text>
                                <Text
                                  fontSize="sm"
                                  color={eventoAcuerdo.status === 'ACCEPTED' ? 'green.800' : 'orange.800'}
                                  lineClamp={2}
                                >
                                  {eventoAcuerdo.notas}
                                </Text>
                              </VStack>
                            </HStack>
                          )}
                        </SimpleGrid>

                        <SimpleGrid columns={{ base: 1, sm: 2 }} gap={3} w="full">
                          <Button
                            colorPalette={eventoAcuerdo.status === 'ACCEPTED' ? 'green' : 'orange'}
                            variant="outline"
                            size="sm"
                            onClick={onAcuerdoDetailsOpen}><Icon as={FaInfoCircle} />Ver todos los detalles
                                                      </Button>
                          {(eventoConversacionId || evento.bandaUserId || evento.cofradiaUserId) && (
                            <Button colorPalette="blue" variant="outline" size="sm" onClick={goToAcuerdoChat}><Icon as={FaEnvelope} />Chat
                                                          </Button>
                          )}
                          {userType === 'banda' &&
                            evento.status === 'pending' &&
                            eventoAcuerdo.status === 'PENDING' &&
                            !bandaVistaResumidaDesdeChat && (
                              <>
                                <Button colorPalette="green" size="sm" onClick={onRespondAcuerdoOpen}><Icon as={FaCheckCircle} />Aceptar
                                                                  </Button>
                                <Button
                                  colorPalette="red"
                                  variant="outline"
                                  size="sm"
                                  onClick={onRejectAcuerdoOpen}><Icon as={FaTimes} />Rechazar
                                                                  </Button>
                              </>
                            )}
                          {evento.status === 'confirmed' &&
                            !eventoEfectivamenteFinalizado &&
                            eventoAcuerdo.status === 'ACCEPTED' &&
                            !bandaVistaResumidaDesdeChat && (
                              <Button
                                colorPalette="red"
                                variant="outline"
                                size="sm"
                                onClick={onRescindAcuerdoOpen}
                                gridColumn={{ base: 'auto', sm: 'span 2' }}><Icon as={FaTimes} />Rescindir acuerdo
                                                              </Button>
                            )}
                        </SimpleGrid>
                      </VStack>
                    </Card.Body>
                  </Card.Root>
                )}
              </>
            )}

            <Card.Root
              bg={cardBg}
              shadow="lg"
              rounded="2xl"
              overflow={fichaUnificadaAcuerdoConfirmado ? 'hidden' : undefined}
              borderWidth={fichaUnificadaAcuerdoConfirmado ? '1px' : undefined}
              borderColor={fichaUnificadaAcuerdoConfirmado ? heroCardBorderColor : undefined}
            >
              {fichaUnificadaAcuerdoConfirmado && (
                <>
                <Card.Body p={{ base: 4, md: 6 }} pb={{ base: 3, md: 4 }}>
                  <HStack justify="space-between" flexWrap="wrap" gap={4} align="flex-start">
                    <HStack gap={3} flexWrap="wrap" align="center">
                      <Button
                        variant="ghost"
                        size="sm"
                        onClick={() => navigate(`${routePrefix}/eventos`)}><Icon as={FaArrowLeft} />Volver
                                              </Button>
                      <Badge colorPalette={getStatusColor(statusUi)} fontSize="sm" px={3} py={1} rounded="full">
                        <Icon as={getStatusIcon(statusUi)} mr={1} />
                        {getStatusText(statusUi)}
                      </Badge>
                      {statusUi !== 'confirmed' && (
                        <Badge colorPalette="green" fontSize="sm" px={3} py={1} rounded="full">
                          <Icon as={FaHandshake} mr={1} />
                          Acuerdo aceptado
                        </Badge>
                      )}
                    </HStack>
                    <HStack gap={2} flexWrap="wrap">
                      {userType === 'cofradia' &&
                        evento.status !== 'cancelled' &&
                        !eventoEfectivamenteFinalizado &&
                        !hasActiveAcuerdo() && (
                          <Button
                            variant="outline"
                            colorPalette="purple"
                            onClick={openEditModal}
                            size={{ base: 'sm', md: 'md' }}><Icon as={FaEdit} />Editar
                                                      </Button>
                        )}
                      {userType === 'cofradia' &&
                        evento.status !== 'cancelled' &&
                        !eventoEfectivamenteFinalizado && (
                        <Tooltip content="Cancelar evento" showArrow>
                          <IconButton
                            colorPalette="red"
                            variant="outline"
                            onClick={onDeleteEventoOpen}
                            size={{ base: 'sm', md: 'md' }}
                            aria-label="Eliminar evento"><Icon as={FaTrash} /></IconButton>
                        </Tooltip>
                      )}
                    </HStack>
                  </HStack>
                </Card.Body>

                <Box
                  px={{ base: 4, md: 6 }}
                  py={4}
                  bg={acuerdoCardBgAccepted}
                  borderTopWidth="1px"
                  borderBottomWidth="1px"
                  borderColor="green.200"
                >
                  <Flex
                    direction={{ base: 'column', md: 'row' }}
                    gap={4}
                    align={{ base: 'stretch', md: 'center' }}
                    justify="space-between"
                  >
                    <HStack gap={4} align="center" flex={1} minW={0}>
                      <Icon as={FaHandshake} color="green.600" boxSize={6} flexShrink={0} />
                      <Avatar.Root size="md"><Avatar.Fallback name={acuerdoOtherName}>{<Icon as={userType === 'banda' ? FaChurch : FaMusic} />}</Avatar.Fallback><Avatar.Image src={acuerdoOtherAvatar} /></Avatar.Root>
                      <VStack align="start" gap={0} minW={0} flex={1}>
                        <Text fontSize="xs" fontWeight="700" color="green.800" textTransform="uppercase" letterSpacing="0.06em">
                          {userType === 'banda' ? 'Cofradía' : 'Banda'}
                        </Text>
                        <Text
                          as={acuerdoOtherNameIsClickable ? 'button' : 'span'}
                          fontSize="md"
                          fontWeight="bold"
                          color="green.900"
                          lineClamp={1}
                          cursor={acuerdoOtherNameIsClickable ? 'pointer' : 'default'}
                          textAlign="left"
                          onClick={acuerdoOtherNameIsClickable ? goToAcuerdoOtherProfile : undefined}
                          _hover={
                            acuerdoOtherNameIsClickable
                              ? { textDecoration: 'underline', color: 'purple.600' }
                              : undefined
                          }
                        >
                          {acuerdoOtherName}
                        </Text>
                        {eventoAcuerdo?.precio ? (
                          <HStack gap={1}>
                            <Icon as={FaEuroSign} color="green.600" boxSize={4} />
                            <Text fontSize="sm" fontWeight="700" color="green.800">
                              {eventoAcuerdo.precio}€
                            </Text>
                          </HStack>
                        ) : null}
                      </VStack>
                    </HStack>
                    <HStack gap={2} flexWrap="wrap" justify="flex-end" flexShrink={0}>
                      {(eventoConversacionId || evento.bandaUserId || evento.cofradiaUserId) && (
                        <Button colorPalette="blue" variant="outline" size="sm" onClick={goToAcuerdoChat}><Icon as={FaEnvelope} />Chat
                                                  </Button>
                      )}
                      <Button
                        colorPalette="green"
                        variant="outline"
                        size="sm"
                        onClick={onAcuerdoDetailsOpen}><Icon as={FaInfoCircle} />Ver acuerdo completo
                                              </Button>
                      {evento.status === 'confirmed' &&
                        !eventoEfectivamenteFinalizado &&
                        eventoAcuerdo?.status === 'ACCEPTED' &&
                        !bandaVistaResumidaDesdeChat && (
                        <Button
                          colorPalette="red"
                          variant="outline"
                          size="sm"
                          onClick={onRescindAcuerdoOpen}><Icon as={FaTimes} />Rescindir
                                                  </Button>
                      )}
                    </HStack>
                  </Flex>
                </Box>

                {(puedeDejarResena || (eventoEfectivamenteFinalizado && yaDejoResena && fichaUnificadaAcuerdoConfirmado)) && (
                  <Box
                    px={{ base: 4, md: 6 }}
                    py={4}
                    bg={yaDejoResena ? 'green.50' : 'blue.50'}
                    borderTopWidth="1px"
                    borderBottomWidth="1px"
                    borderColor={yaDejoResena ? 'green.200' : 'blue.200'}
                  >
                    <Flex
                      direction={{ base: 'column', md: 'row' }}
                      gap={4}
                      align={{ base: 'stretch', md: 'center' }}
                      justify="space-between"
                    >
                      <HStack gap={3} align="flex-start" flex={1} minW={0}>
                        <Icon
                          as={yaDejoResena ? FaCheckCircle : FaStar}
                          color={yaDejoResena ? 'green.600' : 'blue.600'}
                          boxSize={6}
                          flexShrink={0}
                          mt={0.5}
                        />
                        <VStack align="start" gap={1} minW={0}>
                          <Text fontWeight="700" color={yaDejoResena ? 'green.800' : 'blue.800'}>
                            {yaDejoResena ? '¡Gracias por tu reseña!' : 'El evento ha finalizado'}
                          </Text>
                          <Text fontSize="sm" color={yaDejoResena ? 'green.700' : 'blue.700'}>
                            {yaDejoResena
                              ? 'Tu valoración ya está registrada. Las reseñas son anónimas en el perfil de la otra parte.'
                              : `Puedes reseñar a ${userType === 'banda' ? 'la entidad religiosa' : 'la banda'}. Tu opinión ayuda a mejorar y posicionar su perfil.`}
                          </Text>
                        </VStack>
                      </HStack>
                      {puedeDejarResena ? (
                        <Button
                          colorPalette="blue"
                          size="sm"
                          flexShrink={0}
                          onClick={openReviewModal}
                        >
                          <Icon as={FaComments} />
                          Dejar reseña
                        </Button>
                      ) : null}
                    </Flex>
                  </Box>
                )}

                <Box position="relative">
                  <Box
                    h={{ base: '210px', md: '280px' }}
                    bgImage={evento.cartel ? `url(${resolveUploadsUrl(evento.cartel)})` : undefined}
                    bgSize="cover"
                    bgPos="center"
                    bgColor={heroFallbackBg}
                  />
                  <Box
                    position="absolute"
                    inset={0}
                    bgGradient={
                      evento.cartel
                        ? 'linear(to-t, rgba(0,0,0,0.78), rgba(0,0,0,0.10))'
                        : 'linear(to-t, rgba(124,58,237,0.18), rgba(124,58,237,0.06))'
                    }
                  />
                  <Box position="absolute" left={0} right={0} bottom={0} p={{ base: 4, md: 6 }}>
                    <VStack align="start" gap={3}>
                      <Heading
                        size={{ base: 'md', md: 'lg' }}
                        color={evento.cartel ? 'white' : heroTitleNoCartelColor}
                      >
                        {evento.eventName}
                      </Heading>
                      <HStack gap={2} flexWrap="wrap">
                        {evento.duration ? (
                          <Badge colorPalette="orange" variant={evento.cartel ? 'solid' : 'subtle'} rounded="full" px={3} py={1}>
                            <Icon as={FaClock} mr={2} />
                            {evento.duration}
                          </Badge>
                        ) : null}
                      </HStack>
                    </VStack>
                  </Box>
                </Box>
                </>
              )}

                <Card.Body p={{ base: 4, md: 6 }}>
                  <Tabs.Root value={tabsControlledValue(activeTab)} onValueChange={tabsOnValueChange(setActiveTab)} variant='subtle' colorPalette="purple">
                  <Tabs.List mb={6} gap={2}>
                    <Tab value="0" fontWeight="600" fontSize={{ base: 'sm', md: 'md' }}>
                      <Icon as={FaInfoCircle} mr={2} />
                      Detalles
                    </Tab>
                    {userType === 'cofradia' && evento.status === 'pending' && !hasActiveAcuerdo() && (
                      <Tab value="1" fontWeight="600" fontSize={{ base: 'sm', md: 'md' }}>
                        <Icon as={FaSearch} mr={2} />
                        Buscar banda
                      </Tab>
                    )}
                  </Tabs.List>

                  <TabPanels>
                    {/* Tab 1: Detalles del evento */}
                    <TabPanel value="0" px={0}>
                      <VStack gap={6} align="stretch">
                        {bandaVistaResumidaDesdeChat && (
                          <Alert.Root status="info" rounded="xl" variant="subtle">
                            <Alert.Indicator />
                            <Box>
                              <Text fontSize="sm">
                                Vista resumida desde el chat: no se muestran las notas internas de la entidad.
                              </Text>
                            </Box>
                          </Alert.Root>
                        )}

                        {userType === 'banda' && (bandaEntidadNombre || showBandaSiguientePaso) ? (
                          <Card.Root
                            bg={cardBg}
                            rounded="2xl"
                            borderWidth="1px"
                            borderColor="purple.200"
                            shadow="sm"
                            overflow="hidden"
                          >
                            <Card.Body p={{ base: 4, md: 5 }}>
                              <VStack align="stretch" gap={4}>
                                {bandaEntidadNombre ? (
                                  <HStack
                                    gap={3}
                                    align="center"
                                    justify="space-between"
                                    flexWrap="wrap"
                                  >
                                    <HStack
                                      gap={3}
                                      minW={0}
                                      flex={1}
                                      as={bandaEntidadClickable ? 'button' : 'div'}
                                      type={bandaEntidadClickable ? 'button' : undefined}
                                      cursor={bandaEntidadClickable ? 'pointer' : 'default'}
                                      onClick={bandaEntidadClickable ? goToBandaEntidadProfile : undefined}
                                      textAlign="left"
                                      _hover={
                                        bandaEntidadClickable
                                          ? { opacity: 0.9 }
                                          : undefined
                                      }
                                    >
                                      <Avatar.Root size="lg" bg="purple.100" color="purple.700" flexShrink={0}>
                                        <Avatar.Fallback name={bandaEntidadNombre}>
                                          <Icon as={FaChurch} />
                                        </Avatar.Fallback>
                                        <Avatar.Image src={evento.cofradiaAvatar || acuerdoOtherAvatar} />
                                      </Avatar.Root>
                                      <VStack align="start" gap={0} minW={0}>
                                        <Text
                                          fontSize="xs"
                                          fontWeight="700"
                                          color="purple.600"
                                          textTransform="uppercase"
                                          letterSpacing="0.05em"
                                        >
                                          Entidad religiosa
                                        </Text>
                                        <Text fontSize="lg" fontWeight="bold" color={textColor} lineClamp={2}>
                                          {bandaEntidadNombre}
                                        </Text>
                                        {bandaEntidadClickable ? (
                                          <Text fontSize="xs" color="purple.500">
                                            Ver perfil
                                          </Text>
                                        ) : null}
                                      </VStack>
                                    </HStack>
                                    {bandaPuedeAbrirChat ? (
                                      <Button
                                        colorPalette="blue"
                                        variant="outline"
                                        size="sm"
                                        onClick={goToAcuerdoChat}
                                        flexShrink={0}
                                      >
                                        <Icon as={FaEnvelope} />
                                        Ir al chat
                                      </Button>
                                    ) : null}
                                  </HStack>
                                ) : null}

                                {showBandaSiguientePaso ? (
                                  <Alert.Root status="info" rounded="xl" variant="subtle">
                                    <Alert.Indicator />
                                    <Box flex={1}>
                                      <Alert.Title fontSize="sm" mb={1}>
                                        Siguiente paso
                                      </Alert.Title>
                                      <Alert.Description fontSize="sm" display="block">
                                        {eventoAcuerdo?.status === 'PENDING' ? (
                                          <>
                                            La entidad ya te ha propuesto un acuerdo. Revísalo arriba y{' '}
                                            <strong>acéptalo o recházalo</strong>. Mientras tanto puedes seguir
                                            coordinando por el chat de Cadencya.
                                          </>
                                        ) : (
                                          <>
                                            El siguiente paso es llegar a un acuerdo con{' '}
                                            <strong>{bandaEntidadNombre || 'la entidad religiosa'}</strong> a
                                            través del <strong>chat de Cadencya</strong>. Cuando la entidad
                                            proponga un acuerdo, podrás aceptarlo o rechazarlo desde esta
                                            pantalla.
                                          </>
                                        )}
                                      </Alert.Description>
                                      {bandaPuedeAbrirChat && eventoAcuerdo?.status !== 'PENDING' ? (
                                        <Button
                                          mt={3}
                                          size="sm"
                                          colorPalette="purple"
                                          onClick={goToAcuerdoChat}
                                        >
                                          <Icon as={FaEnvelope} />
                                          Abrir chat con la entidad
                                        </Button>
                                      ) : null}
                                    </Box>
                                  </Alert.Root>
                                ) : null}
                              </VStack>
                            </Card.Body>
                          </Card.Root>
                        ) : null}

                        {!fichaUnificadaAcuerdoConfirmado && (
                        <>
                        {/* Hero */}
                        <Card.Root
                          overflow="hidden"
                          rounded="2xl"
                          borderWidth="1px"
                          borderColor={heroCardBorderColor}
                          bg={cardBg}
                          shadow="lg"
                        >
                          <Box position="relative">
                            <Box
                              h={{ base: '210px', md: '280px' }}
                              bgImage={evento.cartel ? `url(${resolveUploadsUrl(evento.cartel)})` : undefined}
                              bgSize="cover"
                              bgPos="center"
                              bgColor={heroFallbackBg}
                            />
                            <Box
                              position="absolute"
                              inset={0}
                              bgGradient={evento.cartel ? 'linear(to-t, rgba(0,0,0,0.78), rgba(0,0,0,0.10))' : 'linear(to-t, rgba(124,58,237,0.18), rgba(124,58,237,0.06))'}
                            />

                            <Box position="absolute" left={0} right={0} bottom={0} p={{ base: 4, md: 6 }}>
                              <VStack align="start" gap={3}>
                                <Heading
                                  size={{ base: 'md', md: 'lg' }}
                                  color={evento.cartel ? 'white' : heroTitleNoCartelColor}
                                >
                                  {evento.eventName}
                                </Heading>

                                {userType === 'banda' && bandaEntidadNombre ? (
                                  <HStack gap={2} flexWrap="wrap">
                                    <Badge
                                      colorPalette="purple"
                                      variant={evento.cartel ? 'solid' : 'subtle'}
                                      rounded="full"
                                      px={3}
                                      py={1}
                                    >
                                      <Icon as={FaChurch} mr={2} />
                                      {bandaEntidadNombre}
                                    </Badge>
                                  </HStack>
                                ) : null}

                                <HStack gap={2} flexWrap="wrap">
                                  {evento.duration ? (
                                    <Badge colorPalette="orange" variant={evento.cartel ? 'solid' : 'subtle'} rounded="full" px={3} py={1}>
                                      <Icon as={FaClock} mr={2} />
                                      {evento.duration}
                                    </Badge>
                                  ) : null}
                                </HStack>
                              </VStack>
                            </Box>
                          </Box>
                        </Card.Root>
                        </>
                        )}

                        <VStack gap={{ base: 6, md: 10 }} align="stretch" w="full" pt={{ base: 0, md: 1 }}>
                          <SimpleGrid columns={{ base: 1, md: 2 }} gap={{ base: 4, md: 5 }} w="full">
                            <Box
                              rounded="2xl"
                              borderWidth="1px"
                              borderColor={detailSurfaceBorder}
                              bg={cardBg}
                              p={{ base: 4, md: 6 }}
                              shadow="sm"
                            >
                              <HStack gap={3} mb={2}>
                                <Flex
                                  align="center"
                                  justify="center"
                                  w={10}
                                  h={10}
                                  rounded="xl"
                                  bg={detailLocationIconBg}
                                  color="purple.600"
                                >
                                  <Icon as={FaCalendarCheck} boxSize={5} />
                                </Flex>
                                <Heading as="h3" size="sm" color={detailSectionTitle} letterSpacing="0.05em" textTransform="uppercase">
                                  Fecha
                                </Heading>
                              </HStack>
                              <Text fontSize={{ base: 'lg', md: 'xl' }} fontWeight="700" color={textColor}>
                                {new Date(evento.date).toLocaleDateString('es-ES', {
                                  weekday: 'long',
                                  day: 'numeric',
                                  month: 'long',
                                  year: 'numeric',
                                })}
                              </Text>
                            </Box>
                            <Box
                              rounded="2xl"
                              borderWidth="1px"
                              borderColor={detailSurfaceBorder}
                              bg={cardBg}
                              p={{ base: 4, md: 6 }}
                              shadow="sm"
                            >
                              <HStack gap={3} mb={2}>
                                <Flex
                                  align="center"
                                  justify="center"
                                  w={10}
                                  h={10}
                                  rounded="xl"
                                  bg={detailTimeIconBg}
                                  color="blue.600"
                                >
                                  <Icon as={FaClock} boxSize={5} />
                                </Flex>
                                <Heading as="h3" size="sm" color={detailSectionTitle} letterSpacing="0.05em" textTransform="uppercase">
                                  Horario
                                </Heading>
                              </HStack>
                              <Text fontSize={{ base: 'lg', md: 'xl' }} fontWeight="700" color={textColor}>
                                {evento.timeEnd ? `${evento.timeStart} – ${evento.timeEnd}` : evento.timeStart || '—'}
                              </Text>
                            </Box>
                          </SimpleGrid>

                          {(evento.description || (evento.notes && !bandaVistaResumidaDesdeChat)) ? (
                            <Box
                              w="full"
                              rounded="2xl"
                              borderWidth="1px"
                              borderColor={detailSurfaceBorder}
                              bg={detailSurfaceBg}
                              p={{ base: 5, md: 8 }}
                              position="relative"
                              overflow="hidden"
                              shadow="sm"
                            >
                              <Box position="absolute" left={0} top={0} bottom={0} w="4px" bg="purple.500" roundedLeft="2xl" />
                              <VStack align="stretch" gap={{ base: 5, md: 7 }} pl={{ base: 2, md: 3 }}>
                                {evento.description ? (
                                  <Box>
                                    <Heading as="h3" size="sm" color={detailSectionTitle} letterSpacing="0.06em" textTransform="uppercase" mb={3}>
                                      Descripción
                                    </Heading>
                                    <Text fontSize={{ base: 'md', md: 'lg' }} color={textColor} whiteSpace="pre-wrap" lineHeight="tall">
                                      {evento.description}
                                    </Text>
                                  </Box>
                                ) : null}
                                {evento.notes && !bandaVistaResumidaDesdeChat ? (
                                  <Box pt={evento.description ? 2 : 0} borderTopWidth={evento.description ? '1px' : 0} borderColor={detailSurfaceBorder}>
                                    <Heading as="h3" size="sm" color={detailSectionTitle} letterSpacing="0.06em" textTransform="uppercase" mb={3} mt={evento.description ? 4 : 0}>
                                      Notas
                                    </Heading>
                                    <Text fontSize={{ base: 'sm', md: 'md' }} color={textColor} whiteSpace="pre-wrap" lineHeight="tall">
                                      {evento.notes}
                                    </Text>
                                  </Box>
                                ) : null}
                              </VStack>
                            </Box>
                          ) : null}

                          <Box w="full">
                            <HStack justify="space-between" align="center" flexWrap="wrap" gap={3} mb={{ base: 4, md: 5 }}>
                              <HStack gap={3}>
                                <Flex
                                  align="center"
                                  justify="center"
                                  w={10}
                                  h={10}
                                  rounded="xl"
                                  bg={detailLocationIconBg}
                                  color="purple.600"
                                >
                                  <Icon as={FaMapMarkerAlt} boxSize={5} />
                                </Flex>
                                <VStack align="start" gap={0}>
                                  <Heading as="h3" size="md" color={detailSectionTitle}>
                                    Ubicaciones
                                  </Heading>
                                  <Text fontSize="sm" color="gray.500">
                                    Salida, entrada y recorrido en el mapa
                                  </Text>
                                </VStack>
                              </HStack>
                              <Badge colorPalette={evento.sameLocation ? 'green' : 'purple'} variant="subtle" rounded="full" px={4} py={1.5} fontSize="sm">
                                {evento.sameLocation ? 'Mismo punto de salida y entrada' : 'Salida y entrada distintas'}
                              </Badge>
                            </HStack>

                            <SimpleGrid columns={{ base: 1, md: 2 }} gap={{ base: 4, md: 5 }} mb={{ base: 4, md: 6 }}>
                              <Box
                                rounded="2xl"
                                borderWidth="1px"
                                borderColor={detailSurfaceBorder}
                                bg={cardBg}
                                p={{ base: 4, md: 6 }}
                                shadow="sm"
                              >
                                <HStack gap={2} mb={3}>
                                  <Badge colorPalette="purple" rounded="md" px={2.5} py={0.5}>
                                    Salida
                                  </Badge>
                                </HStack>
                                <Text fontSize={{ base: 'md', md: 'lg' }} fontWeight="600" color={textColor} lineHeight="short">
                                  {evento.locationStart || '—'}
                                </Text>
                              </Box>
                              {!evento.sameLocation ? (
                                <Box
                                  rounded="2xl"
                                  borderWidth="1px"
                                  borderColor={detailSurfaceBorder}
                                  bg={cardBg}
                                  p={{ base: 4, md: 6 }}
                                  shadow="sm"
                                >
                                  <HStack gap={2} mb={3}>
                                    <Badge colorPalette="red" rounded="md" px={2.5} py={0.5}>
                                      Entrada
                                    </Badge>
                                  </HStack>
                                  <Text fontSize={{ base: 'md', md: 'lg' }} fontWeight="600" color={textColor} lineHeight="short">
                                    {evento.locationEnd || '—'}
                                  </Text>
                                </Box>
                              ) : (
                                <Box
                                  rounded="2xl"
                                  borderWidth="1px"
                                  borderStyle="dashed"
                                  borderColor={detailSurfaceBorder}
                                  bg={detailSurfaceBg}
                                  p={{ base: 4, md: 6 }}
                                  display="flex"
                                  alignItems="center"
                                  justifyContent="center"
                                >
                                  <Text fontSize="sm" color="gray.500" textAlign="center">
                                    La ceremonia continúa en el mismo lugar que la salida.
                                  </Text>
                                </Box>
                              )}
                            </SimpleGrid>

                            {evento.latStart != null && evento.lngStart != null ? (
                              <Box
                                rounded="2xl"
                                overflow="hidden"
                                borderWidth="1px"
                                borderColor={detailSurfaceBorder}
                                shadow="lg"
                                h="clamp(300px, 52vh, 560px)"
                                minH="280px"
                              >
                                <ActuacionMapPreview
                                  lat={evento.latStart}
                                  lng={evento.lngStart}
                                  latFin={(evento.sameLocation ? { lat: evento.latStart, lng: evento.lngStart } : { lat: evento.latEnd, lng: evento.lngEnd })?.lat}
                                  lngFin={(evento.sameLocation ? { lat: evento.latStart, lng: evento.lngStart } : { lat: evento.latEnd, lng: evento.lngEnd })?.lng}
                                  height="100%"
                                />
                              </Box>
                            ) : (
                              <Box
                                rounded="2xl"
                                borderWidth="1px"
                                borderStyle="dashed"
                                borderColor={detailSurfaceBorder}
                                bg={detailSurfaceBg}
                                py={16}
                                px={6}
                                textAlign="center"
                              >
                                <Icon as={FaMapMarkerAlt} boxSize={10} color="gray.400" mb={3} />
                                <Text color="gray.500" fontSize="md">
                                  No hay coordenadas guardadas para mostrar el mapa.
                                </Text>
                              </Box>
                            )}
                          </Box>

                          {evento.fotos && evento.fotos.length > 0 ? (
                            <Box w="full">
                              <HStack justify="space-between" align="center" mb={{ base: 4, md: 5 }} flexWrap="wrap" gap={2}>
                                <Heading as="h3" size="md" color={detailSectionTitle}>
                                  Galería
                                </Heading>
                                <Badge colorPalette="purple" variant="subtle" rounded="full" px={3} py={1}>
                                  {evento.fotos.length} {evento.fotos.length === 1 ? 'imagen' : 'imágenes'}
                                </Badge>
                              </HStack>
                              <SimpleGrid columns={{ base: 2, sm: 3, md: 4, lg: 5 }} gap={{ base: 3, md: 4 }}>
                                {evento.fotos.map((u) => {
                                  const src = resolveUploadsUrl(u);
                                  return (
                                    <Box
                                      key={u}
                                      as="a"
                                      href={src}
                                      target="_blank"
                                      rel="noreferrer"
                                      rounded="xl"
                                      overflow="hidden"
                                      borderWidth="1px"
                                      borderColor={detailSurfaceBorder}
                                      shadow="sm"
                                      _hover={{ transform: 'translateY(-4px)', shadow: 'xl' }}
                                      transition="all 0.2s ease"
                                    >
                                      <AspectRatio ratio={1}>
                                        <Image src={src} alt="Foto del evento" objectFit="cover" />
                                      </AspectRatio>
                                    </Box>
                                  );
                                })}
                              </SimpleGrid>
                            </Box>
                          ) : null}

                          {evento.videos && evento.videos.length > 0 ? (
                            <Box w="full">
                              <HStack justify="space-between" align="center" mb={{ base: 4, md: 5 }} flexWrap="wrap" gap={2}>
                                <Heading as="h3" size="md" color={detailSectionTitle}>
                                  Vídeos
                                </Heading>
                                <Badge colorPalette="red" variant="subtle" rounded="full" px={3} py={1}>
                                  {evento.videos.length}
                                </Badge>
                              </HStack>
                              <VStack gap={{ base: 8, md: 10 }} align="stretch">
                                {evento.videos.map((v, idx) => {
                                  const videoUrl = v?.url ?? v?.link ?? v?.href;
                                  const id = getYouTubeId(videoUrl);
                                  const title = v?.titulo || `Vídeo ${idx + 1}`;
                                  if (!id) {
                                    return (
                                      <Alert.Root key={`${videoUrl}-${idx}`} status="warning" variant="subtle" rounded="xl">
                                        <Alert.Indicator />
                                        <Text fontSize="sm">
                                          No se pudo interpretar el enlace: <strong>{videoUrl || '(vacío)'}</strong>
                                        </Text>
                                      </Alert.Root>
                                    );
                                  }
                                  return (
                                    <Box key={`${id}-${idx}`}>
                                      <Text fontSize={{ base: 'md', md: 'lg' }} fontWeight="700" mb={3} color={detailSectionTitle}>
                                        {title}
                                      </Text>
                                      <Box
                                        position="relative"
                                        w="full"
                                        maxW="1000px"
                                        mx={{ md: 'auto' }}
                                        pt="56.25%"
                                        rounded="2xl"
                                        overflow="hidden"
                                        borderWidth="1px"
                                        borderColor={detailSurfaceBorder}
                                        shadow="lg"
                                      >
                                        <Box
                                          as="iframe"
                                          title={title}
                                          src={`https://www.youtube.com/embed/${id}`}
                                          position="absolute"
                                          top={0}
                                          left={0}
                                          w="full"
                                          h="full"
                                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                          allowFullScreen
                                        />
                                      </Box>
                                    </Box>
                                  );
                                })}
                              </VStack>
                            </Box>
                          ) : null}
                        </VStack>

                        {/* Bandas favoritas (solo si aún no hay acuerdo confirmado) */}
                        {showBandasFavoritasEnDetalle && (
                          <>
                            <Separator />
                            <Box>
                              <HStack gap={2} mb={4}>
                                <Icon as={FaHeart} color="yellow.500" w={5} h={5} />
                                <Text fontSize="lg" fontWeight="bold" color="yellow.700">
                                  Bandas favoritas ({eventShortlists[evento.id].length})
                                </Text>
                              </HStack>
                              
                              <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} gap={4} w="full">
                                {eventShortlists[evento.id].map((banda) => (
                                  <Card.Root 
                                    key={banda.id}
                                    bg={shortlistFavCardBg}
                                    borderWidth="2px"
                                    borderColor="yellow.400"
                                    position="relative"
                                    transition="all 0.2s"
                                    _hover={{ shadow: 'md', transform: 'translateY(-2px)' }}
                                  >
                                    {/* Solo mostrar cruz si NO hay acuerdo propuesto y NO hay conversación */}
                                    {!bandaAcuerdosStatus[banda.id]?.hasPendingAcuerdo && !banda.conversacionId && (
                                      <Tooltip content="Quitar de favoritas">
                                        <IconButton
                                          position="absolute"
                                          top={2}
                                          right={2}
                                          size="xs"
                                          variant="ghost"
                                          colorPalette="red"
                                          onClick={() => handleRemoveFromShortlist(evento.id, banda.id)}
                                          aria-label="Quitar de favoritas"
                                          zIndex={1}><FaTimes /></IconButton>
                                      </Tooltip>
                                    )}
                                    <Card.Body p={4}>
                                      <VStack gap={3} align="stretch">
                                        <HStack gap={3}>
                                          <Avatar.Root size="md"><Avatar.Fallback name={banda.name}>{<Icon as={FaMusic} />}</Avatar.Fallback><Avatar.Image src={banda.avatar} /></Avatar.Root>
                                          <VStack align="start" gap={0} flex={1} minW={0}>
                                            <Text fontWeight="bold" fontSize="sm" lineClamp={1}>
                                              {banda.name}
                                            </Text>
                                            <HStack gap={1}>
                                              <Icon as={FaMapMarkerAlt} color="gray.500" boxSize={3} />
                                              <Text fontSize="xs" color={textColor} lineClamp={1}>
                                                {banda.location}
                                              </Text>
                                            </HStack>
                                          </VStack>
                                        </HStack>
                                        
                                        <VStack gap={2} w="full">
                                          {/* Mostrar botones según el estado del acuerdo */}
                                          {bandaAcuerdosStatus[banda.id]?.hasPendingAcuerdo ? (
                                            <>
                                              <Badge colorPalette="purple" w="full" py={1} textAlign="center">
                                                {bandaAcuerdosStatus[banda.id]?.acuerdoStatus === 'ACCEPTED' 
                                                  ? 'Acuerdo aceptado' 
                                                  : 'Acuerdo propuesto'}
                                              </Badge>
                                              <Button
                                                size="sm"
                                                colorPalette="purple"
                                                variant="outline"
                                                w="full"
                                                onClick={() => navigate(`/ver-perfil-banda?id=${banda.id}`)}
                                              >
                                                Ver perfil
                                              </Button>
                                              <Button
                                                size="sm"
                                                colorPalette="blue"
                                                w="full"
                                                onClick={() => navigate(`${routePrefix}/mensajes?conversacion=${bandaAcuerdosStatus[banda.id]?.conversacionId}`)}><Icon as={FaEnvelope} boxSize={3} />Chat
                                                                                              </Button>
                                              {/* Botón para cancelar acuerdo (solo si está PENDING) */}
                                              {bandaAcuerdosStatus[banda.id]?.acuerdoStatus === 'PENDING' && (
                                                <Button
                                                  size="sm"
                                                  colorPalette="red"
                                                  variant="outline"
                                                  w="full"
                                                  onClick={() => handleCancelAcuerdo(banda)}><Icon as={FaTimes} boxSize={3} />Cancelar acuerdo
                                                                                                  </Button>
                                              )}
                                            </>
                                          ) : (
                                            <>
                                              {/* Si hay un acuerdo activo con otra banda, solo mostrar Ver perfil y Chat */}
                                              {hasActiveAcuerdo() ? (
                                                <>
                                                  <Button
                                                    size="sm"
                                                    colorPalette="purple"
                                                    variant="outline"
                                                    w="full"
                                                    onClick={() => navigate(`/ver-perfil-banda?id=${banda.id}`)}
                                                  >
                                                    Ver perfil
                                                  </Button>
                                                  <Button
                                                    size="sm"
                                                    colorPalette="blue"
                                                    variant="outline"
                                                    w="full"
                                                    onClick={async () => {
                                                      try {
                                                        // Buscar o crear conversación para este evento y banda
                                                        const response = await mensajesAPI.createConversacion(
                                                          banda.userId,
                                                          evento.id
                                                        );
                                                        const conversacionId = response.data.id;
                                                        // Navegar directamente a esa conversación
                                                        navigate(`${routePrefix}/mensajes?conversacion=${conversacionId}`);
                                                      } catch (error) {
                                                        console.error('Error abriendo conversación:', error);
                                                        navigate(`${routePrefix}/mensajes`);
                                                      }
                                                    }}><Icon as={FaEnvelope} boxSize={3} />Chat
                                                                                                      </Button>
                                                </>
                                              ) : (
                                                <>
                                                  <Button
                                                    size="sm"
                                                    colorPalette="purple"
                                                    w="full"
                                                    onClick={() => handleSelectBandaForAcuerdo(banda)}
                                                  >
                                                    Proponer acuerdo
                                                  </Button>
                                                  <Button
                                                    size="sm"
                                                    colorPalette="blue"
                                                    variant="outline"
                                                    w="full"
                                                    onClick={async () => {
                                                      try {
                                                        // Buscar o crear conversación para este evento y banda
                                                        const response = await mensajesAPI.createConversacion(
                                                          banda.userId,
                                                          evento.id
                                                        );
                                                        const conversacionId = response.data.id;
                                                        // Navegar directamente a esa conversación
                                                        navigate(`${routePrefix}/mensajes?conversacion=${conversacionId}`);
                                                      } catch (error) {
                                                        console.error('Error abriendo conversación:', error);
                                                        navigate(`${routePrefix}/mensajes`);
                                                      }
                                                    }}><Icon as={FaEnvelope} boxSize={3} />Mensaje
                                                                                                      </Button>
                                                </>
                                              )}
                                            </>
                                          )}
                                        </VStack>
                                      </VStack>
                                    </Card.Body>
                                  </Card.Root>
                                ))}
                              </SimpleGrid>
                            </Box>
                          </>
                        )}
                      </VStack>
                    </TabPanel>

                    {/* Tab 2: Buscar banda */}
                    {userType === 'cofradia' && evento.status === 'pending' && !hasActiveAcuerdo() && (
                      <TabPanel value="1" px={0}>
                        <VStack gap={6} align="stretch">
                          {/* Shortlist de bandas */}
                          {showBandasFavoritasEnDetalle && (
                            <Box>
                              <Alert.Root status="info" rounded="xl" mb={4}>
                                <Alert.Indicator />
                                <Box flex="1">
                                  <Alert.Title>Bandas favoritas ({eventShortlists[evento.id].length})</Alert.Title>
                                  <Alert.Description>
                                    Has marcado {eventShortlists[evento.id].length} banda(s) como favoritas. 
                                    Ve a la pestaña «Detalles» para proponer un acuerdo a una de ellas.
                                  </Alert.Description>
                                </Box>
                              </Alert.Root>
                              
                              <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} gap={3} mb={6}>
                                {eventShortlists[evento.id].map((banda) => (
                                  <Card.Root 
                                    key={banda.id}
                                    bg={shortlistFavCardBg}
                                    borderWidth="2px"
                                    borderColor="yellow.400"
                                    position="relative"
                                    transition="all 0.2s"
                                    _hover={{ shadow: 'md', transform: 'translateY(-2px)' }}
                                  >
                                    {!banda.conversacionId && (
                                      <Tooltip content="Quitar de favoritas">
                                        <IconButton
                                          position="absolute"
                                          top={2}
                                          right={2}
                                          size="xs"
                                          variant="ghost"
                                          colorPalette="red"
                                          onClick={() => handleRemoveFromShortlist(evento.id, banda.id)}
                                          aria-label="Quitar de favoritas"
                                          zIndex={1}><FaTimes /></IconButton>
                                      </Tooltip>
                                    )}
                                    <Card.Body p={4}>
                                      <VStack gap={3} align="stretch">
                                        <HStack gap={3}>
                                          <Avatar.Root size="md"><Avatar.Fallback name={banda.name}>{<Icon as={FaMusic} />}</Avatar.Fallback><Avatar.Image src={banda.avatar} /></Avatar.Root>
                                          <VStack align="start" gap={0} flex={1} minW={0}>
                                            <Text fontWeight="bold" fontSize="sm" lineClamp={1}>
                                              {banda.name}
                                            </Text>
                                            <HStack gap={1}>
                                              <Icon as={FaMapMarkerAlt} color="gray.500" boxSize={3} />
                                              <Text fontSize="xs" color={textColor} lineClamp={1}>
                                                {banda.location}
                                              </Text>
                                            </HStack>
                                          </VStack>
                                        </HStack>
                                        
                                        <Button
                                          size="sm"
                                          colorPalette="purple"
                                          variant="outline"
                                          w="full"
                                          onClick={() => navigate(`/ver-perfil-banda?id=${banda.id}`)}
                                        >
                                          Ver perfil
                                        </Button>
                                        <Button
                                          size="sm"
                                          colorPalette="blue"
                                          w="full"
                                          onClick={async () => {
                                            const cid =
                                              banda.conversacionId ||
                                              bandaAcuerdosStatus[banda.id]?.conversacionId;
                                            if (cid) {
                                              navigate(`${routePrefix}/mensajes?conversacion=${cid}`);
                                              return;
                                            }
                                            try {
                                              const response = await mensajesAPI.createConversacion(
                                                banda.userId,
                                                evento.id,
                                              );
                                              navigate(
                                                `${routePrefix}/mensajes?conversacion=${response.data.id}`,
                                              );
                                            } catch (error) {
                                              console.error('Error abriendo conversación:', error);
                                              navigate(`${routePrefix}/mensajes`);
                                            }
                                          }}><Icon as={FaEnvelope} boxSize={3} />Contactar
                                                                                  </Button>
                                      </VStack>
                                    </Card.Body>
                                  </Card.Root>
                                ))}
                              </SimpleGrid>
                              
                              <Separator mb={6} />
                            </Box>
                          )}
                          
                          {/* Componente de búsqueda */}
                          <Search 
                            userType="cofradia"
                            inModal={true}
                            eventDate={evento.date}
                            eventName={evento.eventName || evento.nombre}
                            eventLocation={evento.locationStart || evento.ubicacionSalida || evento.ubicacion}
                            eventLat={evento.latStart ?? evento.lat}
                            eventLng={evento.lngStart ?? evento.lng}
                            eventNotes={evento.notes || evento.notas}
                            onSelectResult={null}
                            shortlistedIds={getShortlistedIds(evento.id)}
                            onAddToShortlist={handleAddToShortlist}
                          />
                        </VStack>
                      </TabPanel>
                    )}
                  </TabPanels>
                </Tabs.Root>
              </Card.Body>
            </Card.Root>
          </VStack>
        </Container>
      </Box>

      {/* Modal proponer acuerdo (asistente por pasos) */}
      <Dialog.Root open={isConfirmAcuerdoOpen} size='xl' placement='center' onOpenChange={e => {
        if (!e.open) {
          onConfirmAcuerdoClose();
        }
      }}>
        <Portal>

          <Dialog.Backdrop bg="blackAlpha.400" backdropFilter="blur(10px)" />
          <Dialog.Positioner>
            <Dialog.Content>
              <Dialog.Header bg="purple.500" color="white" roundedTop="md" pb={4}>
                <VStack align="stretch" gap={3}>
                  <HStack justify="space-between" align="flex-start" gap={3}>
                    <HStack gap={3}>
                      <Icon as={FaHandshake} w={6} h={6} />
                      <Text fontWeight="700" fontSize="lg">
                        Proponer acuerdo
                      </Text>
                    </HStack>
                    <Badge
                      colorPalette="purple"
                      variant="solid"
                      rounded="full"
                      px={3}
                      py={1}
                      bg="whiteAlpha.900"
                      color="purple.700"
                    >
                      Paso {acuerdoProposalStep + 1} / {EVENT_ACUERDO_PROPOSE_STEPS.length}
                    </Badge>
                  </HStack>
                  <Box>
                    <Text fontSize="sm" fontWeight="700">
                      {EVENT_ACUERDO_PROPOSE_STEPS[acuerdoProposalStep]?.title}
                    </Text>
                    <Text fontSize="xs" color="purple.100">
                      {EVENT_ACUERDO_PROPOSE_STEPS[acuerdoProposalStep]?.subtitle}
                    </Text>
                  </Box>
                  <Progress.Root
                    value={(acuerdoProposalStep / (EVENT_ACUERDO_PROPOSE_STEPS.length - 1)) * 100}
                    size="sm"
                    colorPalette="whiteAlpha"
                    bg="whiteAlpha.300"
                    rounded="full">
                    <Progress.Track>
                      <Progress.Range />
                    </Progress.Track>
                  </Progress.Root>
                </VStack>
              </Dialog.Header>
              <Dialog.CloseTrigger color="white" />
              <Dialog.Body py={6}>
                {selectedBandaForAcuerdo && (
                  <VStack gap={6} align="stretch">
                    {acuerdoProposalStep === 0 && (
                      <Box
                        bg="green.50"
                        p={5}
                        rounded="xl"
                        borderWidth="2px"
                        borderColor="green.200"
                      >
                        <VStack gap={4} align="stretch">
                          <HStack gap={3}>
                            <Avatar.Root size="lg"><Avatar.Fallback name={selectedBandaForAcuerdo.banda.name}>{<Icon as={FaMusic} />}</Avatar.Fallback><Avatar.Image src={selectedBandaForAcuerdo.banda.avatar} /></Avatar.Root>
                            <VStack align="start" gap={1} flex={1}>
                              <Text fontSize="xl" fontWeight="bold" color="green.800">
                                {selectedBandaForAcuerdo.banda.name}
                              </Text>
                              <HStack gap={1}>
                                <Icon as={FaMapMarkerAlt} color="green.600" boxSize={4} />
                                <Text fontSize="sm" color="green.700">
                                  {selectedBandaForAcuerdo.banda.location}
                                </Text>
                              </HStack>
                            </VStack>
                          </HStack>

                          <Separator borderColor="green.300" />

                          <VStack gap={2} align="stretch">
                            <HStack>
                              <Icon as={FaCalendarCheck} color="green.600" boxSize={4} />
                              <Text fontSize="sm" fontWeight="medium" color="green.900">
                                Evento:
                              </Text>
                              <Text fontSize="sm" color="green.700">
                                {evento.eventName}
                              </Text>
                            </HStack>
                            <HStack>
                              <Icon as={FaClock} color="green.600" boxSize={4} />
                              <Text fontSize="sm" fontWeight="medium" color="green.900">
                                Fecha:
                              </Text>
                              <Text fontSize="sm" color="green.700">
                                {new Date(evento.date).toLocaleDateString('es-ES', {
                                  weekday: 'long',
                                  day: 'numeric',
                                  month: 'long',
                                  year: 'numeric',
                                })}
                              </Text>
                            </HStack>
                            <HStack>
                              <Icon as={FaMapMarkerAlt} color="green.600" boxSize={4} />
                              <Text fontSize="sm" fontWeight="medium" color="green.900">
                                Ubicación:
                              </Text>
                              <Text fontSize="sm" color="green.700">
                                {evento.sameLocation || !evento.locationEnd
                                  ? evento.locationStart
                                  : `${evento.locationStart} → ${evento.locationEnd}`}
                              </Text>
                            </HStack>
                          </VStack>
                        </VStack>
                      </Box>
                    )}

                    {acuerdoProposalStep === 1 && (
                      <Field.Root required>
                        <Field.Label fontSize="sm">Descripción del acuerdo</Field.Label>
                        <Textarea
                          value={acuerdoData.descripcion}
                          onChange={(e) =>
                            setAcuerdoData({ ...acuerdoData, descripcion: e.target.value })
                          }
                          placeholder="Describe los términos del acuerdo..."
                          rows={6}
                        />
                        <Field.HelperText fontSize="xs">
                          La banda verá este texto antes de aceptar o rechazar la propuesta.
                        </Field.HelperText>
                      </Field.Root>
                    )}

                    {acuerdoProposalStep === 2 && (
                      <VStack gap={4} align="stretch">
                        <Field.Root>
                          <Field.Label fontSize="sm">Precio acordado (€)</Field.Label>
                          <NumberInput.Root
                            value={String(acuerdoData.precio)}
                            onValueChange={(details) =>
                              setAcuerdoData({
                                ...acuerdoData,
                                precio: parseFloat(details.value) || 0,
                              })
                            }
                            min={0}
                            precision={2}
                          >
                            <NumberInput.Input placeholder="0.00" />
                            <NumberInput.Control>
                              <NumberInput.IncrementTrigger />
                              <NumberInput.DecrementTrigger />
                            </NumberInput.Control>
                          </NumberInput.Root>
                          <Field.HelperText fontSize="xs">
                            Indica el precio que ofreces a la banda por este evento (puede ser 0).
                          </Field.HelperText>
                        </Field.Root>

                        <Field.Root>
                          <Field.Label fontSize="sm">Notas adicionales</Field.Label>
                          <Textarea
                            value={acuerdoData.notas}
                            onChange={(e) =>
                              setAcuerdoData({ ...acuerdoData, notas: e.target.value })
                            }
                            placeholder="Añade cualquier información adicional relevante..."
                            rows={4}
                          />
                          <Field.HelperText fontSize="xs">
                            Horarios específicos, requisitos técnicos, condiciones especiales, etc.
                          </Field.HelperText>
                        </Field.Root>
                      </VStack>
                    )}

                    {acuerdoProposalStep === 3 && (
                      <VStack gap={4} align="stretch">
                        <Box bg="green.50" p={4} rounded="lg" borderWidth="1px" borderColor="green.200">
                          <Text fontSize="xs" fontWeight="600" color="green.800" textTransform="uppercase">
                            Banda
                          </Text>
                          <Text fontWeight="bold" color="green.900">
                            {selectedBandaForAcuerdo.banda.name}
                          </Text>
                          <Text fontSize="sm" color="green.700" mt={1}>
                            {evento.eventName} · {new Date(evento.date).toLocaleDateString('es-ES')}
                          </Text>
                        </Box>

                        <Box>
                          <Text fontSize="xs" fontWeight="600" color="gray.500" textTransform="uppercase">
                            Descripción
                          </Text>
                          <Box
                            p={3}
                            bg="gray.50"
                            rounded="md"
                            maxH="140px"
                            overflowY="auto"
                            borderWidth="1px"
                            borderColor="gray.200"
                          >
                            <Text fontSize="sm" whiteSpace="pre-wrap">
                              {acuerdoData.descripcion}
                            </Text>
                          </Box>
                        </Box>

                        {(acuerdoData.precio > 0 || acuerdoData.notas?.trim()) && (
                          <VStack align="stretch" gap={2}>
                            {acuerdoData.precio > 0 && (
                              <HStack gap={2}>
                                <Icon as={FaEuroSign} color="green.600" />
                                <Text fontSize="sm" fontWeight="600">
                                  Precio: {acuerdoData.precio}€
                                </Text>
                              </HStack>
                            )}
                            {acuerdoData.notas?.trim() && (
                              <Box>
                                <Text fontSize="xs" fontWeight="600" color="gray.500" textTransform="uppercase">
                                  Notas
                                </Text>
                                <Text fontSize="sm" whiteSpace="pre-wrap">
                                  {acuerdoData.notas}
                                </Text>
                              </Box>
                            )}
                          </VStack>
                        )}

                        <Box bg={disclaimerBoxBg} p={4} rounded="lg" borderWidth="1px" borderColor={disclaimerBoxBorder}>
                          <Alert.Root
                            status="warning"
                            variant='subtle'
                            borderRadius="md"
                            borderStartWidth='3px'
                            borderStartColor='colorPalette.solid'>
                            <Alert.Indicator />
                            <Box>
                              <Alert.Title fontSize="sm">Aviso importante</Alert.Title>
                              <Alert.Description fontSize="xs" display="block">
                                Cadencya no se responsabiliza del contenido ni de los acuerdos pactados entre las partes y no
                                intermedia ningún trato legal. Cadencya únicamente facilita la conexión entre entidad y banda
                                mediante su servicio.
                              </Alert.Description>
                            </Box>
                          </Alert.Root>
                          <Field.Root mt={3} required>
                            <Checkbox.Root
                              onCheckedChange={(details) => setAcuerdoAceptaDisclaimer(details.checked === true)}
                              checked={acuerdoAceptaDisclaimer}
                            ><Checkbox.HiddenInput /><Checkbox.Control><Checkbox.Indicator /></Checkbox.Control><Checkbox.Label>He leído y acepto el aviso legal anterior
                                                        </Checkbox.Label></Checkbox.Root>
                          </Field.Root>
                        </Box>

                        <Alert.Root status="info" rounded="lg">
                          <Alert.Indicator />
                          <Box>
                            <Alert.Title fontSize="sm">¿Qué sucederá después?</Alert.Title>
                            <Alert.Description fontSize="xs">
                              Se enviará esta propuesta a la banda. Podrá aceptarla o rechazarla desde el chat. El
                              evento permanecerá en estado «Pendiente» hasta que la banda acepte.
                            </Alert.Description>
                          </Box>
                        </Alert.Root>
                      </VStack>
                    )}
                  </VStack>
                )}
              </Dialog.Body>
              <Dialog.Footer bg="gray.50" roundedBottom="md">
                <HStack w="full" justify="space-between" flexWrap="wrap" gap={2}>
                  <Button
                    variant="ghost"
                    onClick={() => setAcuerdoProposalStep((s) => Math.max(0, s - 1))}
                    disabled={acuerdoProposalStep === 0 || isSubmittingAcuerdoProposal}
                  >
                    Atrás
                  </Button>
                  <HStack gap={2}>
                    <Button variant="ghost" onClick={onConfirmAcuerdoClose} disabled={isSubmittingAcuerdoProposal}>
                      Cancelar
                    </Button>
                    {acuerdoProposalStep < EVENT_ACUERDO_PROPOSE_STEPS.length - 1 ? (
                      <Button
                        colorPalette="purple"
                        onClick={() =>
                          setAcuerdoProposalStep((s) =>
                            Math.min(EVENT_ACUERDO_PROPOSE_STEPS.length - 1, s + 1),
                          )
                        }
                        disabled={!canAdvanceAcuerdoProposalStep(acuerdoProposalStep)}
                      >
                        Siguiente
                      </Button>
                    ) : (
                      <Button
                        colorPalette="purple"
                        onClick={handleConfirmAcuerdo}
                        size="lg"
                        fontWeight="700"
                        px={6}
                        loading={isSubmittingAcuerdoProposal}
                        disabled={!acuerdoData.descripcion.trim() || !acuerdoAceptaDisclaimer}><Icon as={FaHandshake} />Enviar propuesta
                                          </Button>
                    )}
                  </HStack>
                </HStack>
              </Dialog.Footer>
            </Dialog.Content>
          </Dialog.Positioner>

        </Portal>
      </Dialog.Root>

      {/* Modal de confirmación para cancelar acuerdo */}
      <Dialog.Root open={isCancelAcuerdoOpen} size='md' placement='center' onOpenChange={e => {
        if (!e.open) {
          onCancelAcuerdoClose();
        }
      }}>
        <Portal>

          <Dialog.Backdrop bg="blackAlpha.400" backdropFilter="blur(10px)" />
          <Dialog.Positioner>
            <Dialog.Content>
              <Dialog.Header bg="red.500" color="white" roundedTop="md">
                <HStack gap={3}>
                  <Icon as={FaTimes} w={6} h={6} />
                  <Text>Cancelar Acuerdo</Text>
                </HStack>
              </Dialog.Header>
              <Dialog.CloseTrigger color="white" />
              <Dialog.Body py={6}>
                {selectedBandaToCancel && (
                  <VStack gap={4} align="stretch">
                    <Alert.Root status="warning" rounded="lg">
                      <Alert.Indicator />
                      <Box>
                        <Alert.Title fontSize="sm">¿Estás seguro?</Alert.Title>
                        <Alert.Description fontSize="xs">
                          Esta acción cancelará la propuesta de acuerdo enviada a {selectedBandaToCancel.name}. 
                          La banda permanecerá en tu lista de favoritas y podrás proponerle un nuevo acuerdo cuando quieras.
                        </Alert.Description>
                      </Box>
                    </Alert.Root>

                    <Box
                      bg="gray.50"
                      p={4}
                      rounded="lg"
                      borderWidth="1px"
                      borderColor="gray.200"
                    >
                      <HStack gap={3}>
                        <Avatar.Root size="md"><Avatar.Fallback name={selectedBandaToCancel.name}>{<Icon as={FaMusic} />}</Avatar.Fallback><Avatar.Image src={selectedBandaToCancel.image} /></Avatar.Root>
                        <VStack align="start" gap={0}>
                          <Text fontWeight="bold">{selectedBandaToCancel.name}</Text>
                          <Badge colorPalette="purple">Acuerdo propuesto</Badge>
                        </VStack>
                      </HStack>
                    </Box>
                  </VStack>
                )}
              </Dialog.Body>
              <Dialog.Footer bg="gray.50" roundedBottom="md">
                <Button
                  variant="ghost"
                  mr={3}
                  onClick={onCancelAcuerdoClose}
                >
                  No, mantener acuerdo
                </Button>
                <Button colorPalette="red" onClick={handleConfirmCancelAcuerdo}><Icon as={FaTimes} />Sí, cancelar acuerdo
                              </Button>
              </Dialog.Footer>
            </Dialog.Content>
          </Dialog.Positioner>

        </Portal>
      </Dialog.Root>

      {/* Modal aceptar acuerdo (banda) */}
      <Dialog.Root open={isRespondAcuerdoOpen} size='md' placement='center' onOpenChange={e => {
        if (!e.open) {
          onRespondAcuerdoClose();
        }
      }}>
        <Portal>

          <Dialog.Backdrop bg="blackAlpha.600" backdropFilter="blur(10px)" />
          <Dialog.Positioner>
            <Dialog.Content>
              <Dialog.Header bg="green.500" color="white" roundedTop="md">
                <HStack gap={3}>
                  <Icon as={FaCheckCircle} w={6} h={6} />
                  <Text>Aceptar acuerdo</Text>
                </HStack>
              </Dialog.Header>
              <Dialog.CloseTrigger color="white" />
              <Dialog.Body py={6}>
                {eventoAcuerdo && (
                  <VStack gap={4} align="stretch">
                    <Text fontSize="md" lineHeight="tall">
                      Estás a punto de aceptar el acuerdo para este evento:
                    </Text>
                    <Box bg="green.50" p={4} rounded="lg" borderWidth="2px" borderColor="green.200">
                      <VStack align="stretch" gap={2}>
                        <Text fontSize="lg" fontWeight="bold" color="green.800">
                          {evento.eventName}
                        </Text>
                        <HStack gap={2}>
                          <Icon as={FaCalendarCheck} color="green.600" />
                          <Text fontSize="sm" color="green.700">
                            {new Date(evento.date).toLocaleDateString('es-ES', {
                              weekday: 'long',
                              year: 'numeric',
                              month: 'long',
                              day: 'numeric',
                            })}
                          </Text>
                        </HStack>
                        <HStack gap={2}>
                          <Icon as={FaMapMarkerAlt} color="green.600" />
                          <Text fontSize="sm" color="green.700">
                            {eventLocationLine || '—'}
                          </Text>
                        </HStack>
                        <HStack gap={2}>
                          <Icon as={FaChurch} color="green.600" />
                          <Text fontSize="sm" color="green.700" fontWeight="medium">
                            {evento.cofradiaName}
                          </Text>
                        </HStack>
                        {eventoAcuerdo.precio ? (
                          <HStack gap={2}>
                            <Icon as={FaEuroSign} color="green.600" />
                            <Text fontSize="sm" color="green.700">
                              {eventoAcuerdo.precio}€
                            </Text>
                          </HStack>
                        ) : null}
                      </VStack>
                    </Box>
                    {eventoAcuerdo.descripcion ? (
                      <Box>
                        <Text fontSize="sm" fontWeight="medium" mb={2}>
                          Descripción del acuerdo:
                        </Text>
                        <Box fontSize="sm" color="gray.600" p={3} bg="gray.50" rounded="md" maxH="200px" overflowY="auto">
                          {eventoAcuerdo.descripcion}
                        </Box>
                      </Box>
                    ) : null}
                    <Field.Root>
                      <Field.Label fontSize="sm" fontWeight="medium">
                        Notas adicionales (opcional)
                      </Field.Label>
                      <Textarea
                        placeholder="Agrega cualquier nota o confirmación adicional..."
                        value={respuestaNotas}
                        onChange={(e) => setRespuestaNotas(e.target.value)}
                        rows={2}
                        resize="vertical"
                      />
                    </Field.Root>
                    {userType === 'banda' ? (
                      <Alert.Root
                        status="info"
                        rounded="lg"
                        variant='subtle'
                        borderStartWidth='3px'
                        borderStartColor='colorPalette.solid'>
                        <Alert.Indicator />
                        <Box>
                          <Alert.Title fontSize="sm">Al aceptar, ocurre lo siguiente</Alert.Title>
                          <Alert.Description fontSize="xs" as="div">
                            <List.Root as='ul' gap={1} pl={1} mt={2} mb={0}>
                              <List.Item>
                                El evento quedará <strong>confirmado</strong> con {evento.cofradiaName || 'la cofradía'} y podrás coordinar los últimos detalles por el chat.
                              </List.Item>
                              <List.Item>
                                La fecha quedará <strong>bloqueada en tu calendario de disponibilidad</strong> (no podrás quedar libre ese día para otro compromiso que use el mismo calendario).
                              </List.Item>
                              <List.Item>
                                Se creará una <strong>nueva actuación</strong> en tu panel de gestión (menú Actuaciones) para este compromiso: ficha, plantilla, encuesta, etc.
                              </List.Item>
                            </List.Root>
                          </Alert.Description>
                        </Box>
                      </Alert.Root>
                    ) : (
                      <Alert.Root status="success" rounded="lg">
                        <Alert.Indicator />
                        <Box>
                          <Alert.Title fontSize="sm">El evento será confirmado</Alert.Title>
                          <Alert.Description fontSize="xs">
                            Al aceptar, el evento se marcará como confirmado y podrás coordinar los últimos detalles con la cofradía.
                          </Alert.Description>
                        </Box>
                      </Alert.Root>
                    )}
                    <Box bg={disclaimerBoxBg} p={4} rounded="lg" borderWidth="1px" borderColor={disclaimerBoxBorder}>
                      <Alert.Root
                        status="warning"
                        variant='subtle'
                        borderRadius="md"
                        borderStartWidth='3px'
                        borderStartColor='colorPalette.solid'>
                        <Alert.Indicator />
                        <Box>
                          <Alert.Title fontSize="sm">Aviso importante</Alert.Title>
                          <Alert.Description fontSize="sm" display="block">
                            Cadencya no se responsabiliza del contenido ni de los acuerdos pactados entre las partes y no
                            intermedia ningún trato legal. Cadencya únicamente facilita la conexión entre entidad y banda
                            mediante su servicio.
                          </Alert.Description>
                        </Box>
                      </Alert.Root>
                      <Field.Root mt={3} required>
                        <Checkbox.Root
                          onCheckedChange={(details) => setAceptaDisclaimerAceptarAcuerdo(details.checked === true)}
                          checked={aceptaDisclaimerAceptarAcuerdo}
                        ><Checkbox.HiddenInput /><Checkbox.Control><Checkbox.Indicator /></Checkbox.Control><Checkbox.Label>He leído y acepto el aviso legal anterior
                        </Checkbox.Label></Checkbox.Root>
                      </Field.Root>
                    </Box>
                  </VStack>
                )}
              </Dialog.Body>
              <Dialog.Footer>
                <Button
                  variant="ghost"
                  mr={3}
                  onClick={() => {
                    onRespondAcuerdoClose();
                    setRespuestaNotas('');
                  }}
                  disabled={isRespondingAcuerdo}
                >
                  Cancelar
                </Button>
                <Button
                  colorPalette="green"
                  onClick={confirmAcceptAcuerdoDetail}
                  loading={isRespondingAcuerdo}
                  loadingText="Aceptando…"
                  disabled={!aceptaDisclaimerAceptarAcuerdo}><Icon as={FaCheckCircle} />Aceptar acuerdo
                </Button>
              </Dialog.Footer>
            </Dialog.Content>
          </Dialog.Positioner>

        </Portal>
      </Dialog.Root>

      {/* Modal rechazar acuerdo (banda) */}
      <Dialog.Root open={isRejectAcuerdoOpen} size='md' placement='center' onOpenChange={e => {
        if (!e.open) {
          onRejectAcuerdoClose();
        }
      }}>
        <Portal>

          <Dialog.Backdrop bg="blackAlpha.600" backdropFilter="blur(10px)" />
          <Dialog.Positioner>
            <Dialog.Content>
              <Dialog.Header bg="red.500" color="white" roundedTop="md">
                <HStack gap={3}>
                  <Icon as={FaTimes} w={6} h={6} />
                  <Text>Rechazar acuerdo</Text>
                </HStack>
              </Dialog.Header>
              <Dialog.CloseTrigger color="white" />
              <Dialog.Body py={6}>
                {eventoAcuerdo && (
                  <VStack gap={4} align="stretch">
                    <Text fontSize="md" lineHeight="tall">
                      Estás a punto de rechazar el acuerdo para este evento:
                    </Text>
                    <Box bg="red.50" p={4} rounded="lg" borderWidth="2px" borderColor="red.200">
                      <VStack align="stretch" gap={2}>
                        <Text fontSize="lg" fontWeight="bold" color="red.800">
                          {evento.eventName}
                        </Text>
                        <HStack gap={2}>
                          <Icon as={FaCalendarCheck} color="red.600" />
                          <Text fontSize="sm" color="red.700">
                            {new Date(evento.date).toLocaleDateString('es-ES', {
                              weekday: 'long',
                              year: 'numeric',
                              month: 'long',
                              day: 'numeric',
                            })}
                          </Text>
                        </HStack>
                        <HStack gap={2}>
                          <Icon as={FaChurch} color="red.600" />
                          <Text fontSize="sm" color="red.700" fontWeight="medium">
                            {evento.cofradiaName}
                          </Text>
                        </HStack>
                      </VStack>
                    </Box>
                    <Field.Root>
                      <Field.Label fontSize="sm" fontWeight="medium">
                        Razón del rechazo (opcional)
                      </Field.Label>
                      <Textarea
                        placeholder="Explica por qué rechazas el acuerdo…"
                        value={respuestaNotas}
                        onChange={(e) => setRespuestaNotas(e.target.value)}
                        rows={3}
                        resize="vertical"
                      />
                    </Field.Root>
                    <Alert.Root status="warning" rounded="lg">
                      <Alert.Indicator />
                      <Box>
                        <Alert.Title fontSize="sm">Se rechazará el acuerdo</Alert.Title>
                        <Alert.Description fontSize="xs">
                          La cofradía será notificada de tu decisión. El evento permanecerá pendiente.
                        </Alert.Description>
                      </Box>
                    </Alert.Root>
                  </VStack>
                )}
              </Dialog.Body>
              <Dialog.Footer>
                <Button
                  variant="ghost"
                  mr={3}
                  onClick={() => {
                    onRejectAcuerdoClose();
                    setRespuestaNotas('');
                  }}
                  disabled={isRespondingAcuerdo}
                >
                  Cancelar
                </Button>
                <Button
                  colorPalette="red"
                  onClick={confirmRejectAcuerdoDetail}
                  loading={isRespondingAcuerdo}
                  loadingText="Rechazando…"><Icon as={FaTimes} />Rechazar acuerdo
                              </Button>
              </Dialog.Footer>
            </Dialog.Content>
          </Dialog.Positioner>

        </Portal>
      </Dialog.Root>

      {/* Modal rescindir acuerdo */}
      <Dialog.Root open={isRescindAcuerdoOpen} size='md' placement='center' onOpenChange={e => {
        if (!e.open) {
          onRescindAcuerdoClose();
        }
      }}>
        <Portal>

          <Dialog.Backdrop bg="blackAlpha.600" backdropFilter="blur(10px)" />
          <Dialog.Positioner>
            <Dialog.Content>
              <Dialog.Header bg="orange.500" color="white" roundedTop="md">
                <HStack gap={3}>
                  <Icon as={FaExclamationTriangle} w={6} h={6} />
                  <Text>Rescindir acuerdo</Text>
                </HStack>
              </Dialog.Header>
              <Dialog.CloseTrigger color="white" />
              <Dialog.Body py={6}>
                {eventoAcuerdo && (
                  <VStack gap={4} align="stretch">
                    <Text fontSize="md" lineHeight="tall">
                      Estás a punto de rescindir el acuerdo confirmado para este evento:
                    </Text>
                    <Box bg="orange.50" p={4} rounded="lg" borderWidth="2px" borderColor="orange.200">
                      <VStack align="stretch" gap={2}>
                        <Text fontSize="lg" fontWeight="bold" color="orange.800">
                          {evento.eventName}
                        </Text>
                        <HStack gap={2}>
                          <Icon as={FaCalendarCheck} color="orange.600" />
                          <Text fontSize="sm" color="orange.700">
                            {new Date(evento.date).toLocaleDateString('es-ES', {
                              weekday: 'long',
                              year: 'numeric',
                              month: 'long',
                              day: 'numeric',
                            })}
                          </Text>
                        </HStack>
                        <HStack gap={2}>
                          <Icon as={userType === 'banda' ? FaChurch : FaMusic} color="orange.600" />
                          <Text fontSize="sm" color="orange.700" fontWeight="medium">
                            {userType === 'banda' ? evento.cofradiaName : evento.bandaName}
                          </Text>
                        </HStack>
                        {eventoAcuerdo.precio ? (
                          <HStack gap={2}>
                            <Icon as={FaEuroSign} color="orange.600" />
                            <Text fontSize="sm" color="orange.700">
                              {eventoAcuerdo.precio}€
                            </Text>
                          </HStack>
                        ) : null}
                      </VStack>
                    </Box>
                    <Field.Root>
                      <Field.Label fontSize="sm" fontWeight="medium">
                        Razón de la rescisión (opcional)
                      </Field.Label>
                      <Textarea
                        placeholder="Explica por qué rescindes el acuerdo…"
                        value={rescindReason}
                        onChange={(e) => setRescindReason(e.target.value)}
                        rows={3}
                        resize="vertical"
                      />
                    </Field.Root>
                    <Alert.Root status="warning" rounded="lg">
                      <Alert.Indicator />
                      <Box>
                        <Alert.Title fontSize="sm">El acuerdo será rescindido</Alert.Title>
                        <Alert.Description fontSize="xs">
                          Al rescindir, el evento volverá a estado pendiente.{' '}
                          {userType === 'banda' ? 'La cofradía' : 'La banda'} será notificada de tu decisión.
                        </Alert.Description>
                      </Box>
                    </Alert.Root>
                  </VStack>
                )}
              </Dialog.Body>
              <Dialog.Footer>
                <Button
                  variant="ghost"
                  mr={3}
                  onClick={() => {
                    onRescindAcuerdoClose();
                    setRescindReason('');
                  }}
                  disabled={isRescindingAcuerdo}
                >
                  Cancelar
                </Button>
                <Button
                  colorPalette="orange"
                  onClick={confirmRescindAcuerdoDetail}
                  loading={isRescindingAcuerdo}
                  loadingText="Rescindiendo…"><Icon as={FaExclamationTriangle} />Rescindir acuerdo
                              </Button>
              </Dialog.Footer>
            </Dialog.Content>
          </Dialog.Positioner>

        </Portal>
      </Dialog.Root>

      {/* Modal de detalles del acuerdo */}
      {eventoAcuerdo && (
        <AcuerdoDetailsModal
          isOpen={isAcuerdoDetailsOpen}
          onClose={onAcuerdoDetailsClose}
          acuerdo={eventoAcuerdo}
          evento={{
            eventName: evento.eventName,
            date: evento.date,
            timeStart: evento.timeStart || evento.time || evento.horaInicio || evento.hora || '',
            location: evento.sameLocation || !evento.locationEnd
              ? evento.locationStart
              : `${evento.locationStart} → ${evento.locationEnd}`,
          }}
          otherParty={{
            name: acuerdoOtherName,
            avatar: acuerdoOtherAvatar,
          }}
          userType={userType}
        />
      )}

      {/* Modal de editar evento (solo cofradía) */}
      <Dialog.Root open={isEditEventoOpen} size='xl' placement='center' scrollBehavior="inside" onOpenChange={e => {
        if (!e.open) {
          onEditEventoClose();
        }
      }}>
        <Portal>

          <Dialog.Backdrop bg="blackAlpha.500" backdropFilter="blur(8px)" />
          <Dialog.Positioner>
            <Dialog.Content
              rounded="2xl"
              overflow="hidden"
              boxShadow="2xl"
              borderWidth="1px"
              borderColor={editModalPanelBorder}
              mx={{ base: 3, md: 4 }}>
              <Dialog.Header
                bg="purple.600"
                bgGradient="to-r"
                gradientFrom="purple.500"
                gradientTo="purple.600"
                color="white"
                pt={6}
                pb={5}
                px={{ base: 5, md: 6 }}
                borderBottomWidth="0"
              >
                <VStack align="start" gap={2}>
                  <HStack gap={3}>
                    <Flex
                      align="center"
                      justify="center"
                      w={10}
                      h={10}
                      rounded="xl"
                      bg="whiteAlpha.200"
                      backdropFilter="auto"
                    >
                      <Icon as={FaEdit} boxSize={5} />
                    </Flex>
                    <VStack align="start" gap={0}>
                      <Text fontSize="xl" fontWeight="bold" lineHeight="short">
                        Editar evento
                      </Text>
                      <Text fontSize="sm" color="whiteAlpha.900" fontWeight="medium">
                        Actualiza fechas, ubicación y multimedia
                      </Text>
                    </VStack>
                  </HStack>
                </VStack>
              </Dialog.Header>
              <Dialog.CloseTrigger color="white" top={4} right={4} rounded="full" bg="whiteAlpha.200" _hover={{ bg: 'whiteAlpha.300' }} />
              <Dialog.Body py={5} px={{ base: 4, md: 6 }} bg={editModalCanvasBg}>
                <VStack gap={5} align="stretch">
                  <Box
                    bg={editModalPanelBg}
                    borderWidth="1px"
                    borderColor={editModalPanelBorder}
                    rounded="xl"
                    p={{ base: 4, md: 5 }}
                    shadow="sm"
                  >
                    <HStack gap={2} mb={4}>
                      <Icon as={FaCalendarCheck} color="purple.500" boxSize={5} />
                      <Text fontWeight="bold" fontSize="md" color={editModalLabelColor}>
                        Datos principales
                      </Text>
                    </HStack>
                    <VStack gap={4} align="stretch">
                      <Field.Root required>
                        <Field.Label fontWeight="semibold" fontSize="sm" color={editModalLabelColor} mb={1.5}>
                          Nombre del evento
                        </Field.Label>
                        <Input
                          placeholder="Ej: Procesión del Domingo de Ramos"
                          value={editEvent.eventName}
                          onChange={(e) => setEditEvent((p) => ({ ...p, eventName: e.target.value }))}
                          rounded="lg"
                          size="md" />
                      </Field.Root>

                      <SimpleGrid columns={{ base: 1, md: 2 }} gap={4}>
                        <Field.Root required>
                          <Field.Label fontWeight="semibold" fontSize="sm" color={editModalLabelColor} mb={1.5}>
                            Fecha
                          </Field.Label>
                          <Input
                            type="date"
                            value={editEvent.date}
                            onChange={(e) => setEditEvent((p) => ({ ...p, date: e.target.value }))}
                            rounded="lg"
                            size="md" />
                        </Field.Root>
                        <Field.Root required>
                          <Field.Label fontWeight="semibold" fontSize="sm" color={editModalLabelColor} mb={1.5}>
                            Hora inicio
                          </Field.Label>
                          <Input
                            type="time"
                            value={editEvent.timeStart}
                            onChange={(e) => setEditEvent((p) => ({ ...p, timeStart: e.target.value }))}
                            rounded="lg"
                            size="md" />
                        </Field.Root>
                      </SimpleGrid>

                      <Field.Root>
                        <Field.Label fontWeight="semibold" fontSize="sm" color={editModalLabelColor} mb={1.5}>
                          Hora final
                        </Field.Label>
                        <Input
                          type="time"
                          value={editEvent.timeEnd}
                          onChange={(e) => setEditEvent((p) => ({ ...p, timeEnd: e.target.value }))}
                          rounded="lg"
                          size="md" />
                        <Field.HelperText fontSize="xs">
                          Si la hora final es anterior a la de inicio, se asume que termina al día siguiente.
                        </Field.HelperText>
                      </Field.Root>
                    </VStack>
                  </Box>

                  <Box
                    bg={editModalPanelBg}
                    borderWidth="1px"
                    borderColor={editModalPanelBorder}
                    rounded="xl"
                    p={{ base: 4, md: 5 }}
                    shadow="sm"
                  >
                    <HStack gap={2} mb={4}>
                      <Icon as={FaMapMarkerAlt} color="red.500" boxSize={5} />
                      <Text fontWeight="bold" fontSize="md" color={editModalLabelColor}>
                        Ubicación
                      </Text>
                    </HStack>
                    <VStack gap={4} align="stretch">
                  <Field.Root required>
                    <Field.Label fontWeight="semibold" fontSize="sm" color={editModalLabelColor} mb={1.5}>
                      Ubicación de salida
                    </Field.Label>
                    <Box position="relative">
                      <Input
                        placeholder="Ej: Iglesia de San Pedro, Sevilla"
                        value={editEvent.locationStart}
                        onChange={(e) => setEditEvent((p) => ({ ...p, locationStart: e.target.value }))}
                        onFocus={() => {
                          if (editStartSuggestions.length > 0) setShowEditStartSuggestions(true);
                        }}
                        autoComplete="off"
                        rounded="lg"
                        size="md" />
                      {showEditStartSuggestions && editStartSuggestions.length > 0 && (
                        <Box
                          position="absolute"
                          top="100%"
                          left={0}
                          right={0}
                          bg={editModalPanelBg}
                          border="1px"
                          borderColor={editModalPanelBorder}
                          borderRadius="xl"
                          mt={1}
                          maxH="200px"
                          overflowY="auto"
                          zIndex={1000}
                          boxShadow="lg"
                        >
                          {editStartSuggestions.map((suggestion, index) => (
                            <Box
                              key={index}
                              p={3}
                              cursor="pointer"
                              _hover={{ bg: editModalSuggestHoverBg }}
                              borderBottom={index < editStartSuggestions.length - 1 ? '1px' : 'none'}
                              borderColor={editModalPanelBorder}
                              onClick={() => {
                                setEditEvent((p) => ({
                                  ...p,
                                  locationStart: suggestion.displayName,
                                  locationEnd: p.sameLocation ? suggestion.displayName : p.locationEnd,
                                }));
                                setEditStartCoordinates({ lat: suggestion.lat, lng: suggestion.lng });
                                if (editEvent.sameLocation) setEditEndCoordinates({ lat: suggestion.lat, lng: suggestion.lng });
                                setShowEditStartSuggestions(false);
                                setEditStartSuggestions([]);
                              }}
                            >
                              <HStack gap={2}>
                                <Icon as={FaMapMarkerAlt} color="purple.500" />
                                <Text fontSize="sm">{suggestion.displayName}</Text>
                              </HStack>
                            </Box>
                          ))}
                        </Box>
                      )}
                    </Box>
                    {isGeocodingEditStart && (
                      <Field.HelperText color="blue.500">
                        <HStack gap={2}>
                          <Spinner size="xs" />
                          <Text>Buscando ubicaciones...</Text>
                        </HStack>
                      </Field.HelperText>
                    )}
                    {!isGeocodingEditStart && editStartCoordinates && !showEditStartSuggestions && (
                      <Field.HelperText color="green.500">✓ Ubicación seleccionada</Field.HelperText>
                    )}
                    {!isGeocodingEditStart && editStartGeocodingError && !showEditStartSuggestions && (
                      <Field.HelperText color="orange.500">⚠ {editStartGeocodingError} (se guardará como texto)</Field.HelperText>
                    )}
                  </Field.Root>

                  <Flex
                    w="full"
                    align="center"
                    justify="space-between"
                    gap={3}
                    flexWrap="wrap"
                    px={4}
                    py={3}
                    rounded="xl"
                    bg={editModalSwitchRowBg}
                    borderWidth="1px"
                    borderColor={editModalSwitchRowBorder}
                  >
                    <Text fontSize="sm" fontWeight="semibold" color={editModalLabelColor}>
                      ¿La llegada coincide con la salida?
                    </Text>
                    <Switch
                      colorPalette="purple"
                      size="md"
                      checked={editEvent.sameLocation}
                      onChange={(e) => {
                        const same = e.target.checked;
                        setEditEvent((p) => ({
                          ...p,
                          sameLocation: same,
                          locationEnd: same ? p.locationStart : p.locationEnd,
                        }));
                      }}
                    />
                  </Flex>

                  {!editEvent.sameLocation && (
                    <Field.Root required>
                      <Field.Label fontWeight="semibold" fontSize="sm" color={editModalLabelColor} mb={1.5}>
                        Ubicación de entrada
                      </Field.Label>
                      <Box position="relative">
                        <Input
                          placeholder="Ej: Catedral de Sevilla, Sevilla"
                          value={editEvent.locationEnd}
                          onChange={(e) => setEditEvent((p) => ({ ...p, locationEnd: e.target.value }))}
                          onFocus={() => {
                            if (editEndSuggestions.length > 0) setShowEditEndSuggestions(true);
                          }}
                          autoComplete="off"
                          rounded="lg"
                          size="md" />
                        {showEditEndSuggestions && editEndSuggestions.length > 0 && (
                          <Box
                            position="absolute"
                            top="100%"
                            left={0}
                            right={0}
                            bg={editModalPanelBg}
                            border="1px"
                            borderColor={editModalPanelBorder}
                            borderRadius="xl"
                            mt={1}
                            maxH="200px"
                            overflowY="auto"
                            zIndex={1000}
                            boxShadow="lg"
                          >
                            {editEndSuggestions.map((suggestion, index) => (
                              <Box
                                key={index}
                                p={3}
                                cursor="pointer"
                              _hover={{ bg: editModalSuggestHoverBg }}
                              borderBottom={index < editEndSuggestions.length - 1 ? '1px' : 'none'}
                              borderColor={editModalPanelBorder}
                              onClick={() => {
                                  setEditEvent((p) => ({ ...p, locationEnd: suggestion.displayName }));
                                  setEditEndCoordinates({ lat: suggestion.lat, lng: suggestion.lng });
                                  setShowEditEndSuggestions(false);
                                  setEditEndSuggestions([]);
                                }}
                              >
                                <HStack gap={2}>
                                  <Icon as={FaMapMarkerAlt} color="purple.500" />
                                  <Text fontSize="sm">{suggestion.displayName}</Text>
                                </HStack>
                              </Box>
                            ))}
                          </Box>
                        )}
                      </Box>
                      {isGeocodingEditEnd && (
                        <Field.HelperText color="blue.500">
                          <HStack gap={2}>
                            <Spinner size="xs" />
                            <Text>Buscando ubicaciones...</Text>
                          </HStack>
                        </Field.HelperText>
                      )}
                      {!isGeocodingEditEnd && editEndCoordinates && !showEditEndSuggestions && (
                        <Field.HelperText color="green.500">✓ Ubicación seleccionada</Field.HelperText>
                      )}
                      {!isGeocodingEditEnd && editEndGeocodingError && !showEditEndSuggestions && (
                        <Field.HelperText color="orange.500">⚠ {editEndGeocodingError} (se guardará como texto)</Field.HelperText>
                      )}
                    </Field.Root>
                  )}

                  {(editStartCoordinates || editEndCoordinates) && (
                    <Box
                      w="full"
                      borderWidth="1px"
                      borderColor={editModalPanelBorder}
                      rounded="xl"
                      overflow="hidden"
                      shadow="sm"
                    >
                      <ActuacionMapPreview
                        lat={editStartCoordinates?.lat}
                        lng={editStartCoordinates?.lng}
                        latFin={(editEvent.sameLocation ? editStartCoordinates : editEndCoordinates)?.lat}
                        lngFin={(editEvent.sameLocation ? editStartCoordinates : editEndCoordinates)?.lng}
                        height="240px"
                      />
                    </Box>
                  )}

                    </VStack>
                  </Box>

                  <Box
                    bg={editModalPanelBg}
                    borderWidth="1px"
                    borderColor={editModalPanelBorder}
                    rounded="xl"
                    p={{ base: 4, md: 5 }}
                    shadow="sm"
                  >
                    <HStack gap={2} mb={4}>
                      <Icon as={FaHourglass} color="blue.500" boxSize={5} />
                      <Text fontWeight="bold" fontSize="md" color={editModalLabelColor}>
                        Detalles del acto
                      </Text>
                    </HStack>
                    <VStack gap={4} align="stretch">
                  <SimpleGrid columns={{ base: 1, md: 2 }} gap={4}>
                    <Field.Root>
                      <Field.Label fontWeight="semibold" fontSize="sm" color={editModalLabelColor} mb={1.5}>
                        Duración
                      </Field.Label>
                      <Input
                        placeholder="Ej: 4 horas"
                        value={editEvent.duration}
                        onChange={(e) => setEditEvent((p) => ({ ...p, duration: e.target.value }))}
                        readOnly={!!editEvent.timeEnd}
                        rounded="lg"
                        size="md" />
                      {editEvent.timeEnd ? (
                        <Field.HelperText fontSize="xs">Calculada automáticamente a partir de Hora inicio y Hora final.</Field.HelperText>
                      ) : null}
                    </Field.Root>

                    {/* Presupuesto eliminado de la UI */}
                  </SimpleGrid>

                  <Field.Root>
                    <Field.Label fontWeight="semibold" fontSize="sm" color={editModalLabelColor} mb={1.5}>
                      Notas adicionales
                    </Field.Label>
                    <Textarea
                      placeholder="Información adicional sobre el evento..."
                      value={editEvent.notes}
                      onChange={(e) => setEditEvent((p) => ({ ...p, notes: e.target.value }))}
                      rows={4}
                      rounded="lg" />
                  </Field.Root>
                    </VStack>
                  </Box>

                  <Box
                    bg={editModalPanelBg}
                    borderWidth="1px"
                    borderColor={editModalPanelBorder}
                    rounded="xl"
                    p={{ base: 4, md: 5 }}
                    shadow="sm"
                  >
                    <HStack gap={2} mb={4}>
                      <Icon as={FaImageIcon} color="purple.500" boxSize={5} />
                      <Text fontWeight="bold" fontSize="md" color={editModalLabelColor}>
                        Multimedia
                      </Text>
                    </HStack>

                    <VStack align="stretch" gap={5}>
                      {/* Cartel */}
                      <Box>
                        <Text fontSize="sm" fontWeight="semibold" color={editModalLabelColor} mb={3}>
                          Cartel / imagen principal
                        </Text>
                        {evento.cartel && !editRemoveCartel && !editCartelFile && (
                          <VStack align="stretch" gap={3} mb={3}>
                            <Image
                              src={resolveUploadsUrl(evento.cartel)}
                              alt="Cartel del evento"
                              w="full"
                              maxH="260px"
                              objectFit="cover"
                              rounded="xl"
                              borderWidth="1px"
                              borderColor="gray.200"
                            />
                            <Button
                              size="sm"
                              variant="outline"
                              colorPalette="red"
                              onClick={() => setEditRemoveCartel(true)}><Icon as={FaTrash} />Quitar cartel
                                                      </Button>
                          </VStack>
                        )}
                        {editRemoveCartel && (
                          <Alert.Root status="warning" variant="subtle" rounded="md" mb={3}>
                            <Alert.Indicator />
                            <Text fontSize="sm">El cartel se eliminará al guardar.</Text>
                          </Alert.Root>
                        )}
                        <Box
                          p={3}
                          rounded="lg"
                          borderWidth="1px"
                          borderStyle="dashed"
                          borderColor={editModalPanelBorder}
                          bg={editModalCanvasBg}
                        >
                          <Input
                            type="file"
                            accept="image/*"
                            size="sm"
                            onChange={(e) => {
                              const f = e.target.files?.[0] || null;
                              setEditCartelFile(f);
                              if (f) setEditRemoveCartel(false);
                            }}
                          />
                        </Box>
                        {editCartelFile && (
                          <HStack mt={3} gap={3} align="center">
                            <Image
                              src={URL.createObjectURL(editCartelFile)}
                              alt="Nuevo cartel"
                              boxSize="72px"
                              objectFit="cover"
                              rounded="md"
                              borderWidth="1px"
                              borderColor="gray.200"
                            />
                            <VStack align="start" gap={0} flex={1}>
                              <Text fontSize="sm" fontWeight="600">
                                {editCartelFile.name}
                              </Text>
                              <Text fontSize="xs" color="gray.500">
                                {(editCartelFile.size / 1024 / 1024).toFixed(2)} MB
                              </Text>
                            </VStack>
                            <IconButton
                              aria-label="Quitar nuevo cartel"
                              size="sm"
                              variant="ghost"
                              colorPalette="red"
                              onClick={() => setEditCartelFile(null)}><Icon as={FaTrash} /></IconButton>
                          </HStack>
                        )}
                      </Box>

                      {/* Galería */}
                      <Box>
                        <Text fontSize="sm" fontWeight="semibold" color={editModalLabelColor} mb={3}>
                          Galería
                        </Text>
                        {Array.isArray(evento.fotos) && evento.fotos.length > 0 ? (
                          <Wrap gap={3} mb={3}>
                            {evento.fotos
                              .filter((u) => !editRemovedFotoUrls.has(u))
                              .map((u) => {
                                const src = resolveUploadsUrl(u);
                                return (
                                  <WrapItem key={u}>
                                    <Box position="relative">
                                      <Box
                                        as="a"
                                        href={src}
                                        target="_blank"
                                        rel="noreferrer"
                                        borderWidth="1px"
                                        borderColor="gray.200"
                                        rounded="lg"
                                        overflow="hidden"
                                      >
                                        <Image src={src} alt="Foto del evento" boxSize="110px" objectFit="cover" />
                                      </Box>
                                      <IconButton
                                        aria-label="Quitar foto"
                                        size="xs"
                                        variant="solid"
                                        colorPalette="red"
                                        position="absolute"
                                        top={1}
                                        right={1}
                                        onClick={() =>
                                          setEditRemovedFotoUrls((prev) => new Set([...Array.from(prev.values()), u]))
                                        }><Icon as={FaTrash} /></IconButton>
                                    </Box>
                                  </WrapItem>
                                );
                              })}
                          </Wrap>
                        ) : (
                          <Text fontSize="sm" color="gray.500" mb={2}>
                            Aún no hay fotos en la galería.
                          </Text>
                        )}
                        <Box
                          p={3}
                          rounded="lg"
                          borderWidth="1px"
                          borderStyle="dashed"
                          borderColor={editModalPanelBorder}
                          bg={editModalCanvasBg}
                        >
                          <Input
                            type="file"
                            accept="image/*"
                            multiple
                            size="sm"
                            onChange={(e) => setEditNewFotos(Array.from(e.target.files || []))}
                          />
                        </Box>
                        {editNewFotos.length > 0 && (
                          <Text fontSize="sm" color="gray.600" mt={2}>
                            Se añadirán {editNewFotos.length} nueva(s) imagen(es) al guardar.
                          </Text>
                        )}
                      </Box>

                      {/* Vídeos */}
                      <Box>
                        <Text fontSize="sm" fontWeight="semibold" color={editModalLabelColor} mb={3}>
                          Vídeos (YouTube)
                        </Text>
                        <SimpleGrid columns={{ base: 1, md: 2 }} gap={3}>
                          <Input
                            placeholder="Título (opcional)"
                            value={editVideoDraft.titulo}
                            onChange={(e) => setEditVideoDraft((p) => ({ ...p, titulo: e.target.value }))}
                            rounded="lg"
                            size="md" />
                          <Input
                            placeholder="Enlace de YouTube"
                            value={editVideoDraft.url}
                            onChange={(e) => setEditVideoDraft((p) => ({ ...p, url: e.target.value }))}
                            rounded="lg"
                            size="md" />
                        </SimpleGrid>
                        <HStack mt={3} align="center" flexWrap="wrap" gap={3}>
                          <Button
                            size="sm"
                            colorPalette="red"
                            variant="outline"
                            onClick={() => {
                              const url = String(editVideoDraft.url || '').trim();
                              if (!url) return;
                              setEditVideos((prev) => [
                                ...prev,
                                { titulo: editVideoDraft.titulo?.trim() || undefined, url },
                              ]);
                              setEditVideoDraft({ titulo: '', url: '' });
                            }}
                            disabled={!String(editVideoDraft.url || '').trim()}><Icon as={FaYoutube} />Añadir vídeo
                                                  </Button>
                          <Text fontSize="xs" color="gray.500" flex="1" minW="200px" m={0}>
                            Pega un enlace de YouTube (p. ej. https://www.youtube.com/watch?v=...).
                          </Text>
                        </HStack>

                        {editVideos.length > 0 && (
                          <VStack align="stretch" mt={4} gap={2}>
                            {editVideos.map((v, idx) => (
                              <HStack
                                key={`${v.url}-${idx}`}
                                p={3}
                                borderWidth="1px"
                                borderColor={editModalPanelBorder}
                                rounded="lg"
                                bg={editModalCanvasBg}
                                justify="space-between"
                              >
                                <HStack gap={2} minW={0}>
                                  <Icon as={FaLink} color="gray.500" />
                                  <VStack gap={0} align="start" minW={0}>
                                    <Text fontSize="sm" fontWeight="600" lineClamp={1}>
                                      {v.titulo || 'Vídeo'}
                                    </Text>
                                    <Text fontSize="xs" color="gray.500" lineClamp={1}>
                                      {v.url}
                                    </Text>
                                  </VStack>
                                </HStack>
                                <IconButton
                                  aria-label="Quitar vídeo"
                                  size="sm"
                                  variant="ghost"
                                  colorPalette="red"
                                  onClick={() => setEditVideos((prev) => prev.filter((_, i) => i !== idx))}><Icon as={FaTrash} /></IconButton>
                              </HStack>
                            ))}
                          </VStack>
                        )}
                      </Box>
                    </VStack>
                  </Box>
                </VStack>
              </Dialog.Body>
              <Dialog.Footer
                bg={editModalFooterBg}
                borderTopWidth="1px"
                borderColor={editModalPanelBorder}
                py={4}
                px={{ base: 4, md: 6 }}
                roundedBottom="2xl"
              >
                <Button variant="ghost" colorPalette="gray" mr={3} onClick={onEditEventoClose}>
                  Cancelar
                </Button>
                <Button
                  colorPalette="purple"
                  onClick={handleSaveEditEvento}
                  loading={isSavingEvento}
                  rounded="lg"
                  shadow="md"
                  _hover={{ shadow: 'lg' }}
                  disabled={
                    !editEvent.eventName ||
                    !editEvent.date ||
                    !editEvent.timeStart ||
                    !editEvent.locationStart ||
                    (!editEvent.sameLocation && !editEvent.locationEnd) ||
                    (!editEvent.timeEnd && !String(editEvent.duration || '').trim())
                  }><Icon as={FaCheckCircle} />Guardar cambios
                              </Button>
              </Dialog.Footer>
            </Dialog.Content>
          </Dialog.Positioner>

        </Portal>
      </Dialog.Root>

      {/* Modal de confirmar eliminación de evento */}
      <Dialog.Root open={isDeleteEventoOpen} size='lg' placement='center' onOpenChange={e => {
        if (!e.open) {
          onDeleteEventoClose();
        }
      }}>
        <Portal>

          <Dialog.Backdrop bg="blackAlpha.600" backdropFilter="blur(10px)" />
          <Dialog.Positioner>
            <Dialog.Content>
              <Dialog.Header bg="red.500" color="white" roundedTop="md">
                <HStack gap={3}>
                  <Icon as={FaExclamationTriangle} w={6} h={6} />
                  <Text>Cancelar Evento</Text>
                </HStack>
              </Dialog.Header>
              <Dialog.CloseTrigger color="white" />
              <Dialog.Body py={6}>
                <VStack gap={5} align="stretch">
                  <Alert.Root status="error" rounded="lg">
                    <Alert.Indicator />
                    <Box flex={1}>
                      <Alert.Title fontSize="md" mb={1}>¿Estás seguro de cancelar este evento?</Alert.Title>
                      <Alert.Description fontSize="sm">
                        Esta acción es permanente y notificará a todas las bandas con las que has iniciado conversaciones.
                      </Alert.Description>
                    </Box>
                  </Alert.Root>

                  <Box
                    bg="gray.50"
                    p={5}
                    rounded="xl"
                    borderWidth="2px"
                    borderColor="red.200"
                  >
                    <VStack gap={3} align="start">
                      <HStack>
                        <Icon as={FaCalendarCheck} color="purple.500" boxSize={5} />
                        <Text fontWeight="bold" fontSize="lg">{evento.eventName}</Text>
                      </HStack>
                      <Text fontSize="sm" color="gray.600">
                        {new Date(evento.date).toLocaleDateString('es-ES', {
                          weekday: 'long',
                          day: 'numeric',
                          month: 'long',
                          year: 'numeric'
                        })}
                      </Text>
                    </VStack>
                  </Box>

                  <Field.Root required>
                    <Field.Label fontWeight="600" fontSize="md">
                      Motivo de la cancelación
                    </Field.Label>
                    <Textarea
                      placeholder="Explica por qué se cancela el evento (será enviado a todas las bandas contactadas)..."
                      value={cancelReason}
                      onChange={(e) => setCancelReason(e.target.value)}
                      rows={4}
                      resize="vertical"
                    />
                    <Field.HelperText fontSize="xs" color="gray.500">
                      Este mensaje será enviado a todas las conversaciones activas del evento
                    </Field.HelperText>
                  </Field.Root>
                </VStack>
              </Dialog.Body>
              <Dialog.Footer bg="gray.50" roundedBottom="md">
                <Button
                  variant="ghost"
                  mr={3}
                  onClick={() => {
                    onDeleteEventoClose();
                    setCancelReason('');
                  }}
                >
                  No, mantener evento
                </Button>
                <Button
                  colorPalette="red"
                  onClick={handleDeleteEvento}
                  loading={isDeletingEvento}
                  disabled={!cancelReason.trim()}><Icon as={FaTrash} />Sí, cancelar evento
                              </Button>
              </Dialog.Footer>
            </Dialog.Content>
          </Dialog.Positioner>

        </Portal>
      </Dialog.Root>

      <ReviewForm
        isOpen={isReviewModalOpen}
        onClose={onReviewModalClose}
        evento={eventoParaResenar}
        onReviewSubmitted={handleReviewSubmitted}
        userType={userType}
      />
    </AppLayout>
  );
};

export default EventDetails;

